// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***************************************************************************************
 * FileName      : main.css
 * Description   : scjeil-smart_ict_lab-app 메인 스타일시트 (애니메이션, 레이아웃, 컴포넌트 스타일)
 * Author        : (주)한국공학기술연구원 박은정
 * Created Date  : 2026.02.03
 * Modified Date : 2026.02.20 헤더 타이틀 h1 주색 적용, 버전 표시 스타일, 순천제일대학교 텍스트 스타일 추가
 * Reference     : mockup/asset/css/main.css
 ***************************************************************************************/

/* 2026.02.03 : 박은정 : 화면 전환 애니메이션 추가 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

/* 2026.02.13 : 박은정 : 매터포트 공간 로딩 중 상태 표시 모달 스타일 추가 */
/* 2026.02.20 : 박은정 : 헤더(48px) 아래부터 표시되도록 top 변경 */
.loading-modal {
  position: fixed;
  top: 48px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.loading-modal--visible {
  opacity: 1;
}

.loading-modal__backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}

/* 2026.02.20 : 박은정 : 3D 공간 로딩 시 배경 이미지 스타일 (background-image로 다운로드 방지) */
.loading-modal__backdrop--bg {
  background-color: #1a1a2e;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  -webkit-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  pointer-events: none;
}

/* 2026.02.20 : 박은정 : 로딩 표시 — 배경 없이 배경 이미지 위에 직접 표시 */
.loading-modal__indicator {
  position: relative;
  z-index: 2;
  text-align: center;
  animation: loadingIndicatorFadeIn 0.6s ease-out;
}

@keyframes loadingIndicatorFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 2026.02.20 : 박은정 : 스피너 크기 확대 (64px → 96px) */
.loading-modal__spinner {
  width: 96px;
  height: 96px;
  margin: 0 auto 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-modal__spinner-svg {
  width: 100%;
  height: 100%;
  animation: loadingSpinnerRotate 1s linear infinite;
}

/* 2026.02.20 : 박은정 : 스피너 흰색 메인 + 진한 테두리 */
.loading-modal__spinner-circle {
  stroke: #FB6544;
  stroke-linecap: round;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  animation: loadingSpinnerDash 1.5s ease-in-out infinite;
}

@keyframes loadingSpinnerRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes loadingSpinnerDash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

/* 2026.02.20 : 박은정 : 로딩 텍스트 흰색 + 진한 테두리 */
.loading-modal__text {
  font-size: 24px;
  color: #FB6544;
  -webkit-text-stroke: 3px #fff;
  margin: 0;
  font-weight: 700;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  paint-order: stroke fill;
}

/* 2026.02.09 : 박은정 : 타이틀 오버레이(Phase 2) 스타일 추가 */
.title-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.title-overlay--visible {
  opacity: 1;
}

.title-overlay__backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.title-overlay__card {
  position: relative;
  z-index: 2;
  background: #ffffff;
  border-radius: 24px;
  padding: 48px;
  max-width: 630px;
  width: 90%;
  text-align: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  animation: titleCardFadeInUp 0.6s ease-out;
}

@keyframes titleCardFadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.title-overlay__logo {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  background: linear-gradient(135deg, #3B82F6 0%, #1e40af 100%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-overlay__logo svg {
  width: 48px;
  height: 48px;
  color: white;
}

.title-overlay__title {
  font-size: 28px;
  font-weight: 700;
  color: #3B82F6;
  margin: 0 0 4px 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.title-overlay__subtitle {
  font-size: 16px;
  color: #6B7280;
  margin: 0 0 24px 0;
  font-weight: 400;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.title-overlay__divider {
  width: 60px;
  height: 2px;
  background-color: #3B82F6;
  margin: 0 auto 24px;
}

.title-overlay__description {
  font-size: 15px;
  color: #6B7280;
  line-height: 1.6;
  margin: 0 0 32px 0;
  font-weight: 400;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.title-overlay__cta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 16px 48px;
  background-color: #3B82F6;
  color: #ffffff;
  border: none;
  border-radius: 9999px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 150ms ease;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.title-overlay__cta-btn:hover {
  background-color: #2563EB;
}

.title-overlay__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
}

.title-overlay__footer-logos {
  display: flex;
  align-items: center;
  gap: 24px;
}

.title-overlay__footer-logo-item {
  font-weight: 300;
  color: #1F2937;
  background: white;
  padding: 10px 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  font-size: 14px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 2026.02.25 : 박은정 : 타이틀 오버레이 하단 기관명 링크 스타일 추가 */
.title-overlay__footer-logo-link {
  text-decoration: none;
}

.title-overlay__footer-info {
  display: flex;
  align-items: center;
  gap: 24px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.8);
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 2026.02.13 : 박은정 : 타이틀 오버레이 카드 하단 버전 표시 스타일 추가 */
.title-overlay__version {
  margin-top: 16px;
  font-size: 12px;
  color: #C0C0C0;
  font-weight: 400;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  letter-spacing: 0.3px;
}

/* 2026.05.15 : 박은정 : 모바일 가로/좁은 화면에서 타이틀 모달 위·아래 잘림 해결 */
/* 2026.05.15 : 박은정 : 화면 가운데 정렬 + 가로 폭 축소 (margin:auto로 스크롤 시에도 안전 중앙) */
@media (max-height: 600px), (max-width: 768px) {
  .title-overlay {
    overflow-y: auto;
    padding: 16px 0 72px;
    -webkit-overflow-scrolling: touch;
  }
  .title-overlay__card {
    padding: 40px 24px 36px;
    border-radius: 18px;
    width: 88%;
    max-width: 560px;
    margin: auto;
  }
  .title-overlay__logo {
    width: 56px;
    height: 56px;
    margin: 0 auto 20px;
    border-radius: 14px;
  }
  .title-overlay__logo svg {
    width: 32px;
    height: 32px;
  }
  .title-overlay__title {
    font-size: 20px;
    margin: 0 0 8px 0;
  }
  .title-overlay__subtitle {
    font-size: 13px;
    margin: 0 0 22px 0;
  }
  .title-overlay__divider {
    margin: 0 auto 22px;
  }
  .title-overlay__description {
    font-size: 13px;
    margin: 0 0 28px 0;
  }
  .title-overlay__description br {
    display: none;
  }
  .title-overlay__cta-btn {
    padding: 12px 32px;
    font-size: 14px;
  }
  .title-overlay__version {
    margin-top: 18px;
    font-size: 11px;
  }
  .title-overlay__footer {
    padding: 8px 12px;
  }
  .title-overlay__footer-logos {
    gap: 8px;
  }
  .title-overlay__footer-logo-item {
    padding: 6px 10px;
    font-size: 11px;
  }
}

/* 2026.05.15 : 박은정 : 모바일 가로(≤450px 높이)에서 타이틀 모달 추가 축소 — 스크롤 없이 한 화면에 표시 */
/* 2026.05.15 : 박은정 : min-height + flex-column 으로 카드가 뷰포트 세로를 충분히 채우도록 함 */
@media (max-height: 450px) {
  .title-overlay {
    padding: 8px 0 40px;
  }
  .title-overlay__card {
    padding: 22px 28px 20px;
    max-width: 520px;
    min-height: calc(100vh - 100px);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .title-overlay__logo {
    width: 48px;
    height: 48px;
    margin: 0 auto 12px;
    border-radius: 12px;
  }
  .title-overlay__logo svg {
    width: 28px;
    height: 28px;
  }
  .title-overlay__title {
    font-size: 17px;
    margin: 0 0 6px 0;
  }
  .title-overlay__subtitle {
    font-size: 12px;
    margin: 0 0 14px 0;
  }
  .title-overlay__divider {
    margin: 0 auto 14px;
    width: 44px;
  }
  .title-overlay__description {
    font-size: 12px;
    line-height: 1.45;
    margin: 0 0 18px 0;
  }
  .title-overlay__cta-btn {
    padding: 10px 28px;
    font-size: 13px;
  }
  .title-overlay__version {
    margin-top: 12px;
    font-size: 10px;
  }
  .title-overlay__footer {
    padding: 5px 12px;
  }
  .title-overlay__footer-logos {
    gap: 6px;
  }
  .title-overlay__footer-logo-item {
    padding: 5px 9px;
    font-size: 10px;
  }
}

/* 2026.02.12 : 박은정 : 진입 애니메이션 오버레이 (건너뛰기 버튼) */
.intro-anim-overlay {
  position: fixed;
  bottom: 40px;
  right: 40px;
  z-index: 10001;
  animation: introAnimOverlayFadeIn 0.5s ease-out;
}

@keyframes introAnimOverlayFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.intro-anim-overlay__skip-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 9999px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 150ms ease, transform 150ms ease;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
}

.intro-anim-overlay__skip-btn:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: scale(1.05);
}

/* 2026.02.09 : 박은정 : 장비 학습하기 모달 + 학습현황 사이드바 스타일 */
.eq-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.25s ease, visibility 0.25s ease;
}

.eq-modal--visible {
  opacity: 1;
  visibility: visible;
}

.eq-modal__backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.35);
}

/* 2026.02.09 : 박은정 : 모달 + 사이드바 가로 배치 래퍼 */
.eq-modal__layout {
  position: relative;
  display: flex;
  align-items: stretch;
  max-height: 85vh;
  animation: eqModalFadeIn 0.3s ease-out;
}

@keyframes eqModalFadeIn {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.eq-modal__card {
  position: relative;
  background: #ffffff;
  border-radius: 24px 0 0 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  width: 400px;
  max-width: 50vw;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 2026.02.09 : 박은정 : 학습현황 사이드바 패널 (모달 오른쪽) */
.eq-modal__sidebar {
  position: relative;
  background: #F9FAFB;
  border-radius: 0 24px 24px 0;
  width: 260px;
  max-width: 35vw;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  border-left: 1px solid #F3F4F6;
}

.eq-modal__sidebar-header {
  display: flex;
  align-items: center;
  gap: 6px;
}

.eq-modal__sidebar-title {
  font-size: 15px;
  font-weight: 600;
  color: #1F2937;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.eq-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #F3F4F6;
}

.eq-modal__header-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.eq-modal__name {
  font-size: 18px;
  font-weight: 600;
  color: #1F2937;
  margin: 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.eq-modal__name-en {
  font-size: 12px;
  color: #9CA3AF;
  font-weight: 400;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.eq-modal__close {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  cursor: pointer;
  color: #9CA3AF;
  background: rgba(0, 0, 0, 0.04);
  border: none;
  transition: all 150ms ease;
}

.eq-modal__close:hover {
  background: rgba(0, 0, 0, 0.08);
  color: #1F2937;
}

.eq-modal__body {
  padding: 20px 24px;
  overflow-y: auto;
}

.eq-modal__desc {
  font-size: 14px;
  color: #6B7280;
  line-height: 1.6;
  margin: 0 0 16px 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.eq-modal__specs {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #F9FAFB;
  border-radius: 12px;
  padding: 12px 16px;
}

.eq-modal__spec-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.eq-modal__spec-label {
  color: #9CA3AF;
  font-weight: 400;
}

.eq-modal__spec-value {
  color: #1F2937;
  font-weight: 500;
}

.eq-modal__footer {
  padding: 16px 24px 20px;
  border-top: 1px solid #F3F4F6;
}

/* 2026.02.09 : 박은정 : 버튼 2개 (이어서 학습하기 + 학습하기) 가로 배치 */
.eq-modal__footer--dual {
  display: flex;
  gap: 8px;
}

.eq-modal__learn-btn {
  display: block;
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 150ms ease, box-shadow 150ms ease;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
}

/* 이어서 학습하기 (보조 버튼 — 아웃라인 스타일) */
.eq-modal__learn-btn--resume {
  background: #ffffff;
  color: #3B82F6;
  border: 1.5px solid #3B82F6;
}

.eq-modal__learn-btn--resume:hover {
  background: rgba(59, 130, 246, 0.06);
}

/* 학습하기 (주 버튼 — 채움 스타일) */
.eq-modal__learn-btn--start {
  background-color: #3B82F6;
  color: #ffffff;
}

.eq-modal__learn-btn--start:hover {
  background-color: #2563EB;
}

/* 2026.02.09 : 박은정 : 모달 내 학습 진행률 바 스타일 추가 */
.eq-modal__progress {
  margin-top: 16px;
}

.eq-modal__progress-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.eq-modal__progress-title {
  font-size: 12px;
  font-weight: 500;
  color: #6B7280;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.eq-modal__progress-value {
  font-size: 12px;
  font-weight: 600;
  color: #3B82F6;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.eq-modal__progress-bar {
  width: 100%;
  height: 6px;
  background: #F3F4F6;
  border-radius: 3px;
  overflow: hidden;
}

.eq-modal__progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #3B82F6, #60A5FA);
  border-radius: 3px;
  transition: width 0.4s ease;
}

/* 2026.02.09 : 박은정 : 사이드바 학습카드 체크리스트 스타일 (세로 목록) */
.eq-modal__checklist {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.eq-modal__checklist-hint {
  font-size: 11px;
  color: #9CA3AF;
  margin-bottom: 2px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.eq-modal__checklist-items {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* 2026.02.09 : 박은정 : 카드 버튼 - 세로 리스트 아이템 스타일 */
.eq-modal__check-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  font-size: 13px;
  font-weight: 500;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1.5px solid transparent;
  cursor: pointer;
  transition: all 150ms ease;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  text-align: left;
  line-height: 1;
}

.eq-modal__check-item:hover {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.eq-modal__check-item--pending {
  background: #ffffff;
  color: #9CA3AF;
}

.eq-modal__check-item--in-progress {
  background: rgba(59, 130, 246, 0.06);
  color: #3B82F6;
}

.eq-modal__check-item--completed {
  background: rgba(16, 185, 129, 0.06);
  color: #10B981;
}

/* 2026.02.09 : 박은정 : 선택된 카드 강조 스타일 */
.eq-modal__check-item--selected {
  border-color: #3B82F6;
  background: rgba(59, 130, 246, 0.08);
  color: #2563EB;
}

.eq-modal__check-item--selected.eq-modal__check-item--completed {
  border-color: #10B981;
  background: rgba(16, 185, 129, 0.08);
  color: #059669;
}

/* 2026.02.09 : 박은정 : 카드 번호 (사이드바 리스트 순번) */
.eq-modal__check-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  background: rgba(0, 0, 0, 0.05);
  color: inherit;
  flex-shrink: 0;
}

.eq-modal__check-item--selected .eq-modal__check-num {
  background: #3B82F6;
  color: #ffffff;
}

.eq-modal__check-item--selected.eq-modal__check-item--completed .eq-modal__check-num {
  background: #10B981;
  color: #ffffff;
}

.eq-modal__check-label {
  flex: 1;
  line-height: 1;
}

.eq-modal__check-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: auto;
}

/* 2026.05.15 : 박은정 : 모바일 가로/좁은 화면에서 학습 모달이 잘리지 않도록 padding/font 축소 + max-height 확대 */
@media (max-height: 600px), (max-width: 768px) {
  .eq-modal__layout {
    max-height: 94vh;
    width: auto;
    max-width: 92vw;
  }
  .eq-modal__card {
    width: 360px;
    max-width: 54vw;
    border-radius: 16px 0 0 16px;
  }
  .eq-modal__sidebar {
    width: 220px;
    max-width: 36vw;
    border-radius: 0 16px 16px 0;
    padding: 12px 14px;
    gap: 10px;
  }
  .eq-modal__sidebar-title {
    font-size: 13px;
  }
  .eq-modal__header {
    padding: 12px 16px;
  }
  .eq-modal__name {
    font-size: 15px;
  }
  .eq-modal__name-en {
    font-size: 11px;
  }
  .eq-modal__close {
    width: 28px;
    height: 28px;
  }
  .eq-modal__body {
    padding: 12px 16px;
  }
  .eq-modal__desc {
    font-size: 12px;
    line-height: 1.5;
    margin: 0 0 10px 0;
  }
  .eq-modal__specs {
    padding: 8px 12px;
    gap: 6px;
  }
  .eq-modal__spec-row {
    font-size: 12px;
  }
  .eq-modal__footer {
    padding: 10px 16px 12px;
  }
  .eq-modal__learn-btn {
    padding: 10px;
    font-size: 13px;
    border-radius: 12px;
  }
  .eq-modal__progress {
    margin-top: 8px;
  }
  .eq-modal__progress-title,
  .eq-modal__progress-value {
    font-size: 11px;
  }
  .eq-modal__check-item {
    padding: 6px 8px;
    font-size: 12px;
    gap: 6px;
  }
  .eq-modal__check-num {
    width: 18px;
    height: 18px;
    font-size: 11px;
  }
}

/* 2026.05.15 : 박은정 : 모바일 세로(≤768px) 및 모바일 가로(≤600px 높이)에서는 학습현황 사이드바 숨기고 카드만 표시 + 학습 버튼 대신 "PC 버전 안내" 문구 */
@media (max-width: 768px), (max-height: 600px) {
  .eq-modal__sidebar {
    display: none;
  }
  .eq-modal__card {
    width: 88vw;
    max-width: 480px;
    border-radius: 18px;
  }
  .eq-modal__footer .eq-modal__learn-btn {
    display: none;
  }
  .eq-modal__footer::after {
    content: '학습은 PC 웹 브라우저로 진행해 주세요';
    display: block;
    text-align: center;
    color: #6B7280;
    font-size: 13px;
    font-weight: 500;
    padding: 12px;
    background: #F9FAFB;
    border-radius: 12px;
    font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  }
}

/* 2026.02.20 : 박은정 : 학습 패널 개요 카드 — 장비 설명 이미지 썸네일 스타일 */
.lp-overview-thumb-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  margin-bottom: 16px;
  cursor: pointer;
}

.lp-overview-thumb {
  width: 100%;
  max-height: 180px;
  object-fit: contain;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  background: #F9FAFB;
  transition: transform 150ms ease, box-shadow 150ms ease;
  padding: 3px;
}

.lp-overview-thumb:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.lp-overview-thumb-hint {
  font-size: 11px;
  color: #9CA3AF;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 2026.02.20 : 박은정 : 학습 패널 개요 카드 — 이미지 팝업 (라이트박스) 스타일 */
.lp-lightbox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
  animation: lpLightboxFadeIn 0.2s ease-out;
  cursor: pointer;
}

@keyframes lpLightboxFadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.lp-lightbox__close {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  cursor: pointer;
  transition: background 150ms ease;
}

.lp-lightbox__close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.lp-lightbox__img {
  max-width: 85vw;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
  cursor: default;
  animation: lpLightboxZoomIn 0.25s ease-out;
}

@keyframes lpLightboxZoomIn {
  from { transform: scale(0.9); opacity: 0; }
  to   { transform: scale(1);   opacity: 1; }
}

/* 2026.02.09 : 박은정 : 하단 장비 선택 탭 바 스타일 추가 (Phase 3) */
.eq-footer {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.4s ease, visibility 0.4s ease, transform 0.4s ease;
  transform: translateX(-50%) translateY(20px);
}

.eq-footer--visible {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

.eq-footer__tabs {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(229, 231, 235, 0.6);
  border-bottom: none;
}

.eq-footer__tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 10px;
  border: 1.5px solid transparent;
  background: #F3F4F6;
  color: #6B7280;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 150ms ease;
  white-space: nowrap;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.eq-footer__tab:hover:not(:disabled) {
  background: #E8EDF3;
  color: #1F2937;
}

.eq-footer__tab--active {
  background: rgba(59, 130, 246, 0.08);
  color: #3B82F6;
  border-color: #3B82F6;
}

.eq-footer__tab--active:hover {
  background: rgba(59, 130, 246, 0.12);
  color: #3B82F6;
}

.eq-footer__tab--disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.eq-footer__tab-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: inherit;
  flex-shrink: 0;
}

.eq-footer__tab-label {
  color: inherit;
  line-height: 1;
}

/* 2026.02.09 : 박은정 : 장비 탭 진행률 뱃지 스타일 추가 */
.eq-footer__tab-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 8px;
  line-height: 1.4;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.eq-footer__tab-badge--progress {
  background: rgba(59, 130, 246, 0.12);
  color: #3B82F6;
}

.eq-footer__tab-badge--complete {
  background: rgba(16, 185, 129, 0.12);
  color: #10B981;
}

.eq-footer__divider {
  width: 1px;
  height: 24px;
  background: #E5E7EB;
  margin: 0 4px;
  flex-shrink: 0;
}

/* 2026.02.09 : 박은정 : 상단 헤더 바 스타일 (항상 표시) */
/* 2026.02.20 : 박은정 : 좌측(타이틀+버전) / 우측(순천제일대학교) 배치를 위해 justify-content 추가 */
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(229, 231, 235, 0.6);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

/* 2026.02.20 : 박은정 : 헤더 좌측 영역 (타이틀 + 버전) 하단 정렬 */
.app-header__left {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

/* 2026.02.20 : 박은정 : h1 태그로 변경, 프로젝트 주색(#3B82F6) 적용 */
.app-header__title {
  font-size: 18px;
  font-weight: 700;
  color: #3B82F6;
  letter-spacing: -0.2px;
  margin: 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  white-space: nowrap;
}

/* 2026.02.20 : 박은정 : 버전 표시 (타이틀 모달 버전 색상 #C0C0C0 동일 적용, h1보다 작은 글자 크기) */
.app-header__version {
  font-size: 12px;
  font-weight: 300;
  color: #C0C0C0;
  letter-spacing: 0.3px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  white-space: nowrap;
}

/* 2026.02.20 : 박은정 : 헤더 우측 순천제일대학교 텍스트 */
.app-header__university {
  font-size: 18px;
  font-weight: 700;
  color: #3B82F6;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  white-space: nowrap;
}

/* 2026.05.15 : 박은정 : 모바일 세로 화면(태블릿 이하)에서 헤더 글씨 줄바뀜 방지 */
@media (max-width: 768px) {
  .app-header {
    padding: 0 12px;
  }
  .app-header__left {
    gap: 6px;
    min-width: 0;
    flex: 1;
  }
  .app-header__title {
    font-size: 13px;
    letter-spacing: -0.3px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .app-header__version {
    font-size: 10px;
  }
  .app-header__university {
    font-size: 13px;
    flex-shrink: 0;
  }
}

/* 2026.05.15 : 박은정 : 휴대폰 세로(≤480px)에서는 university 표기 축약 */
@media (max-width: 480px) {
  .app-header__title {
    font-size: 12px;
  }
  .app-header__version {
    display: none;
  }
  .app-header__university {
    font-size: 12px;
  }
}

.frame {
  height: 100%;
  width: 100%;
  border-width: 0px;
  /* 2026.02.09 : 박은정 : 오버레이가 iframe 위에 표시되도록 z-index 설정 */
  position: relative;
  z-index: 1;
}

.main {
  height: 100%;
  width: 100%;
  position: relative;
  /* 2026.02.09 : 박은정 : 헤더 높이만큼 상단 여백 */
  padding-top: 48px;
  box-sizing: border-box;
}

.video-controls-wrapper {
  z-index: 100;
  position: fixed;
  right: 10px;
  top: 10px;
  float: right;
  width: 200px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.video-controls h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
}

.video-controls button {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: white;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.video-controls button:hover:not(:disabled) {
  background-color: #0056b3;
}

.video-controls button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.video-status {
  margin-top: 10px;
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  font-size: 12px;
  color: #666;
}

.video-status p {
  margin: 0;
}

/* ===========================================================================================
 * 2026.02.09 : 박은정 : 학습 우측 패널 (LearningPanel) 스타일
 * Reference : mockup/learning.html (RIGHT PANEL), mockup/asset/css/layout.css
 * =========================================================================================== */

/* 패널 컨테이너 — 우측에서 슬라이드 인 */
.learning-panel {
  position: fixed;
  top: 48px; /* 헤더 아래 */
  right: 0;
  bottom: 0;
  width: 420px;
  max-width: 100vw;
  z-index: 600;
  background: #ffffff;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  opacity: 0;
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1),
              opacity 0.35s ease;
  overflow-y: auto;
  overflow-x: hidden;
}

.learning-panel--visible {
  transform: translateX(0);
  opacity: 1;
}

/* 패널 헤더 (닫기 버튼) */
.learning-panel__header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 12px 16px 4px;
  flex-shrink: 0;
}

.learning-panel__back {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: none;
  background: rgba(0, 0, 0, 0.04);
  color: #9CA3AF;
  cursor: pointer;
  transition: all 150ms ease;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
}

.learning-panel__back:hover {
  background: rgba(0, 0, 0, 0.08);
  color: #1F2937;
}

/* 장비 개요 영역 */
.learning-panel__overview {
  padding: 4px 24px 20px;
  border-bottom: 1px solid #F3F4F6;
  flex-shrink: 0;
}

.learning-panel__eq-name {
  font-size: 20px;
  font-weight: 700;
  color: #1F2937;
  margin: 0 0 2px 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.learning-panel__eq-sub {
  font-size: 12px;
  color: #9CA3AF;
  margin: 0 0 12px 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.learning-panel__eq-desc {
  font-size: 13px;
  color: #6B7280;
  line-height: 1.6;
  margin: 0 0 16px 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.learning-panel__specs {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: #F9FAFB;
  border-radius: 12px;
  padding: 10px 14px;
}

.learning-panel__spec {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.learning-panel__spec-label {
  color: #9CA3AF;
}

.learning-panel__spec-value {
  color: #1F2937;
  font-weight: 500;
}

/* 학습 과정 목록 헤더 */
.learning-panel__cards {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.learning-panel__cards-header {
  padding: 16px 24px 8px;
  flex-shrink: 0;
}

.learning-panel__cards-title {
  font-size: 15px;
  font-weight: 600;
  color: #1F2937;
  margin: 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.learning-panel__cards-list {
  padding: 0 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* ============================================
 * 아코디언 카드 (.lp-card)
 * ============================================ */
.lp-card {
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #F3F4F6;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.lp-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* 카드 헤더 */
.lp-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  cursor: pointer;
  background: #ffffff;
  transition: background 0.15s ease;
  user-select: none;
}

.lp-card__header:hover {
  background: #FAFBFC;
}

.lp-card__left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.lp-card__number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
  background: #F3F4F6;
  color: #6B7280;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-card--completed .lp-card__number {
  background: rgba(16, 185, 129, 0.1);
  color: #10B981;
}

.lp-card--in-progress .lp-card__number {
  background: rgba(59, 130, 246, 0.1);
  color: #3B82F6;
}

.lp-card--active .lp-card__number {
  background: #3B82F6;
  color: #ffffff;
}

.lp-card__title {
  font-size: 14px;
  font-weight: 500;
  color: #1F2937;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-card__right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.lp-card__status {
  font-size: 11px;
  font-weight: 500;
  color: #9CA3AF;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-card__status--completed {
  color: #10B981;
}

.lp-card__status--in-progress {
  color: #3B82F6;
}

.lp-card__chevron {
  color: #9CA3AF;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.lp-card--active .lp-card__chevron {
  transform: rotate(180deg);
}

/* 아코디언 본문 (펼침/접힘) */
.lp-card__content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.lp-card--active .lp-card__content {
  max-height: 5000px; /* 충분히 큰 값 — monitoring 카드 제어/계측 데이터 포함 */
}

.lp-card__body {
  padding: 0 16px 16px;
}

/* 활성 카드 강조 */
.lp-card--active {
  border-color: #3B82F6;
  box-shadow: 0 2px 12px rgba(59, 130, 246, 0.08);
}

/* ============================================
 * 섹션 콘텐츠 (.lp-section)
 * ============================================ */
.lp-section {
  margin-bottom: 16px;
}

.lp-section:last-child {
  margin-bottom: 0;
}

.lp-section__title {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-section__body {
  font-size: 13px;
  color: #6B7280;
  line-height: 1.6;
  margin: 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 리스트 */
.lp-section__list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.lp-section__list-item {
  font-size: 13px;
  color: #4B5563;
  line-height: 1.5;
  padding-left: 4px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 태그 */
.lp-section__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.lp-section__tag {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 12px;
  background: rgba(59, 130, 246, 0.06);
  color: #3B82F6;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 용어 정의 */
.lp-section__terms {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lp-term {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-term__name {
  color: #1F2937;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: 70px;
}

.lp-term__def {
  color: #6B7280;
  line-height: 1.4;
}

/* 부품 목록 */
.lp-section__parts {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* 2026.02.20 : 박은정 : 구성요소 부품 기본 스타일 */
.lp-part {
  background: #F9FAFB;
  border-radius: 10px;
  padding: 10px 12px;
  transition: all 0.2s ease;
  border: 1.5px solid transparent;
}

/* 2026.02.20 : 박은정 : 핫스팟 태그 연동 가능한 부품 — 클릭 가능 표시 */
.lp-part--clickable {
  cursor: pointer;
}

.lp-part--clickable:hover {
  background: #EFF6FF;
  border-color: #93C5FD;
}

/* 2026.02.20 : 박은정 : 핫스팟 태그가 표시 중인 활성 부품 */
.lp-part--active {
  background: #DBEAFE;
  border-color: #3B82F6;
}

.lp-part--active .lp-part__name {
  color: #1D4ED8;
}

/* 2026.05.14 : 박은정 : 클릭된 부품 바로 아래 인라인 모니터링 데이터 */
.lp-part-inline-monitoring {
  background: #F8FAFC;
  border: 1px solid #DBEAFE;
  border-top: none;
  border-radius: 0 0 10px 10px;
  padding: 8px 12px;
  margin-top: -6px;
  margin-bottom: 8px;
}
.lp-part-inline-monitoring .lp-data-row {
  padding: 4px 0;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}
.lp-part-inline-monitoring .lp-data-row__label {
  color: #475569;
}
.lp-part-inline-monitoring .lp-data-row__value strong {
  color: #0f172a;
}

/* 2026.02.20 : 박은정 : 핫스팟 태그 표시중 뱃지 */
.lp-part__hotspot-badge {
  display: inline-block;
  font-size: 10px;
  color: #2563EB;
  margin-top: 4px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-part__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2px;
}

.lp-part__name {
  font-size: 12px;
  color: #1F2937;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-part__role {
  font-size: 11px;
  color: #6B7280;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-part__detail {
  font-size: 11px;
  color: #9CA3AF;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 데이터 모니터링 행 */
.lp-section__data {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.lp-data-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #F9FAFB;
  border-radius: 8px;
  font-size: 12px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-data-row__left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.lp-data-row__label {
  color: #374151;
}

.lp-data-row__desc {
  font-size: 11px;
  color: #6B7280;
  font-weight: 400;
}

.lp-data-row__right {
  display: flex;
  align-items: center;
}

.lp-data-row__value {
  color: #6B7280;
}

.lp-data-row__value strong {
  color: #1F2937;
  font-weight: 400;
}

/* 2026.02.12 : 박은정 : 우측 패널 모니터링 데이터 섹션 (제어 장비 + 계측 장비) */
.lp-monitoring-data {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 12px;
}

/* 제어 장비 디바이스 카드 (우측 패널 monitoring 카드용) */
.lp-data-device {
  background: #F9FAFB;
  border-radius: 10px;
  padding: 10px 12px;
  border: 1px solid #F3F4F6;
  margin-bottom: 6px;
}

.lp-data-device:last-child {
  margin-bottom: 0;
}

.lp-data-device__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid #F3F4F6;
}

.lp-data-device__id {
  font-size: 12px;
  color: #374151;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-data-device__name {
  font-size: 12px;
  color: #6B7280;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  flex: 1;
}

.lp-data-device__status {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-data-device__status--running {
  background: rgba(16, 185, 129, 0.08);
  color: #059669;
}

.lp-data-device__status--stopped {
  background: rgba(107, 114, 128, 0.08);
  color: #6B7280;
}

/* 계측 장비 센서 그룹 (우측 패널 monitoring 카드용) */
.lp-monitoring-group {
  margin-bottom: 8px;
}

.lp-monitoring-group:last-child {
  margin-bottom: 0;
}

.lp-monitoring-group__heading {
  font-size: 12px;
  color: #374151;
  margin: 0 0 6px 0;
  padding: 4px 8px;
  background: rgba(59, 130, 246, 0.04);
  border-radius: 6px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 시나리오 목록 */
.lp-section__scenarios {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lp-scenario {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #F9FAFB;
  border-radius: 10px;
  font-size: 13px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 2026.02.11 : 박은정 : 클릭 가능한 시나리오 스타일 */
.lp-scenario--clickable {
  cursor: pointer;
  transition: all 0.2s ease;
}

.lp-scenario--clickable:hover {
  background: #EFF6FF;
  border: 1px solid #3B82F6;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
}

.lp-scenario__num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 7px;
  font-size: 11px;
  background: rgba(59, 130, 246, 0.08);
  color: #3B82F6;
  flex-shrink: 0;
}

.lp-scenario__name {
  flex: 1;
  color: #1F2937;
}

.lp-scenario__duration {
  font-size: 11px;
  color: #9CA3AF;
  font-weight: 500;
}

/* 학습 완료 버튼 */
.lp-card__action {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #F3F4F6;
}

.lp-card__complete-btn {
  display: block;
  width: 100%;
  padding: 10px;
  background: #3B82F6;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 150ms ease;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
}

.lp-card__complete-btn:hover {
  background: #2563EB;
}

/* ===========================================================================================
 * 2026.02.12 : 박은정 : 평가 퀴즈 (LearningPanel evaluation 카드) 스타일
 * Reference : doc/equipment-description/*_test.md (객관식 평가 문항)
 * =========================================================================================== */

/* 퀴즈 컨테이너 */
.lp-quiz {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
}

/* 진행 상황 바 */
.lp-quiz__progress {
  display: flex;
  align-items: center;
  gap: 10px;
}

.lp-quiz__progress-info {
  display: flex;
  align-items: baseline;
  gap: 2px;
  flex-shrink: 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-quiz__progress-current {
  font-size: 16px;
  font-weight: 700;
  color: #3B82F6;
}

.lp-quiz__progress-sep {
  font-size: 13px;
  color: #9CA3AF;
}

.lp-quiz__progress-total {
  font-size: 13px;
  color: #6B7280;
  font-weight: 500;
}

.lp-quiz__progress-bar {
  flex: 1;
  height: 6px;
  background: #F3F4F6;
  border-radius: 3px;
  overflow: hidden;
}

.lp-quiz__progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #3B82F6, #60A5FA);
  border-radius: 3px;
  transition: width 0.4s ease;
}

/* 결과 문항 요약 그리드 */
.lp-quiz__summary {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.lp-quiz__summary-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-quiz__summary-item--correct {
  background: rgba(16, 185, 129, 0.06);
  border-color: rgba(16, 185, 129, 0.3);
}

.lp-quiz__summary-item--wrong {
  background: rgba(239, 68, 68, 0.06);
  border-color: rgba(239, 68, 68, 0.3);
}

.lp-quiz__summary-num {
  font-size: 11px;
  font-weight: 600;
  color: #6B7280;
}

.lp-quiz__summary-mark {
  font-size: 14px;
  font-weight: 700;
}

.lp-quiz__summary-item--correct .lp-quiz__summary-mark {
  color: #059669;
}

.lp-quiz__summary-item--wrong .lp-quiz__summary-mark {
  color: #DC2626;
}

/* 결과 박스 */
.lp-quiz__result {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  position: sticky;
  top: 0;
  z-index: 2;
}

.lp-quiz__result--pass {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.08), rgba(16, 185, 129, 0.15));
  border: 1px solid rgba(16, 185, 129, 0.3);
}

.lp-quiz__result--fail {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.08), rgba(239, 68, 68, 0.15));
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.lp-quiz__result-score {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.lp-quiz__result-label {
  font-size: 11px;
  color: #6B7280;
  font-weight: 500;
}

.lp-quiz__result-value {
  font-size: 22px;
  font-weight: 700;
  color: #1F2937;
}

.lp-quiz__result--pass .lp-quiz__result-value {
  color: #059669;
}

.lp-quiz__result--fail .lp-quiz__result-value {
  color: #DC2626;
}

.lp-quiz__result-detail {
  font-size: 13px;
  color: #4B5563;
  flex: 1;
}

.lp-quiz__result-badge {
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
}

.lp-quiz__result-badge--pass {
  background: rgba(16, 185, 129, 0.15);
  color: #059669;
}

.lp-quiz__result-badge--fail {
  background: rgba(239, 68, 68, 0.15);
  color: #DC2626;
}

/* 문항 카드 */
.lp-quiz__question {
  background: #F9FAFB;
  border-radius: 12px;
  padding: 14px 16px;
  border: 1px solid #F3F4F6;
  transition: border-color 0.2s ease;
}

.lp-quiz__question--correct {
  border-color: rgba(16, 185, 129, 0.4);
  background: rgba(16, 185, 129, 0.03);
}

.lp-quiz__question--wrong {
  border-color: rgba(239, 68, 68, 0.4);
  background: rgba(239, 68, 68, 0.03);
}

.lp-quiz__q-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.lp-quiz__q-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  background: rgba(59, 130, 246, 0.08);
  color: #3B82F6;
  flex-shrink: 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-quiz__q-cat {
  font-size: 11px;
  color: #9CA3AF;
  font-weight: 500;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-quiz__q-mark {
  margin-left: auto;
  font-size: 16px;
  font-weight: 700;
}

.lp-quiz__q-mark--correct {
  color: #059669;
}

.lp-quiz__q-mark--wrong {
  color: #DC2626;
}

.lp-quiz__q-text {
  font-size: 13px;
  font-weight: 500;
  color: #1F2937;
  line-height: 1.5;
  margin: 0 0 10px 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 선택지 */
.lp-quiz__choices {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lp-quiz__choice {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #ffffff;
  border: 1.5px solid #E5E7EB;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-quiz__choice:hover {
  border-color: #D1D5DB;
  background: #FAFBFC;
}

.lp-quiz__choice--selected {
  border-color: #3B82F6;
  background: rgba(59, 130, 246, 0.04);
}

.lp-quiz__choice--selected:hover {
  border-color: #3B82F6;
  background: rgba(59, 130, 246, 0.06);
}

.lp-quiz__choice--correct {
  border-color: #10B981 !important;
  background: rgba(16, 185, 129, 0.06) !important;
}

.lp-quiz__choice--wrong {
  border-color: #EF4444 !important;
  background: rgba(239, 68, 68, 0.06) !important;
}

.lp-quiz__choice--disabled {
  cursor: default;
  pointer-events: none;
}

.lp-quiz__choice-num {
  font-size: 13px;
  color: #6B7280;
  flex-shrink: 0;
  line-height: 1.5;
}

.lp-quiz__choice--selected .lp-quiz__choice-num {
  color: #3B82F6;
}

.lp-quiz__choice--correct .lp-quiz__choice-num {
  color: #059669;
  font-weight: 600;
}

.lp-quiz__choice--wrong .lp-quiz__choice-num {
  color: #DC2626;
}

.lp-quiz__choice-text {
  font-size: 13px;
  color: #374151;
  line-height: 1.5;
}

.lp-quiz__choice--correct .lp-quiz__choice-text {
  color: #059669;
  font-weight: 600;
}

.lp-quiz__choice--wrong .lp-quiz__choice-text {
  color: #DC2626;
}

/* 해설 */
.lp-quiz__explanation {
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.6;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lp-quiz__explanation--correct {
  background: rgba(16, 185, 129, 0.06);
  border-left: 3px solid #10B981;
}

.lp-quiz__explanation--wrong {
  background: rgba(239, 68, 68, 0.06);
  border-left: 3px solid #EF4444;
}

.lp-quiz__explanation-label {
  display: inline-block;
  font-weight: 700;
  color: #4B5563;
  margin-right: 6px;
}

.lp-quiz__explanation-text {
  color: #4B5563;
}

/* 액션 버튼 */
.lp-quiz__actions {
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid #F3F4F6;
}

.lp-quiz__submit-btn {
  display: block;
  width: 100%;
  padding: 12px;
  background: #3B82F6;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 150ms ease, opacity 150ms ease;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
}

.lp-quiz__submit-btn:hover:not(:disabled) {
  background: #2563EB;
}

.lp-quiz__submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.lp-quiz__retry-btn {
  display: block;
  width: 100%;
  padding: 12px;
  background: #ffffff;
  color: #3B82F6;
  border: 1.5px solid #3B82F6;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 150ms ease;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
}

.lp-quiz__retry-btn:hover {
  background: rgba(59, 130, 246, 0.04);
}

/* ===========================================================================================
 * 2026.02.11 : 박은정 : 모니터링 좌측 패널 (MonitoringPanel) 스타일
 * Reference : mockup/learning.html (LEFT PANEL), 우측 패널(.learning-panel) 동일 스타일 기반
 * =========================================================================================== */

/* 패널 컨테이너 — 좌측에서 슬라이드 인 (우측 패널과 대칭) */
.monitoring-panel {
  position: fixed;
  top: 48px; /* 헤더 아래 */
  left: 0;
  bottom: 0;
  width: 380px;
  max-width: 100vw;
  z-index: 600;
  background: #ffffff;
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  transform: translateX(-100%);
  opacity: 0;
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1),
              opacity 0.35s ease;
  overflow: hidden;
}

.monitoring-panel--visible {
  transform: translateX(0);
  opacity: 1;
}

/* 2026.02.12 : 박은정 : 패널 헤더 → "모니터링" 타이틀 + 운전 상태 뱃지 (장비명 3중 중복 해소) */
.monitoring-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 12px;
  border-bottom: 1px solid #F3F4F6;
  flex-shrink: 0;
}

.monitoring-panel__title {
  font-size: 16px;
  font-weight: 700;
  color: #1F2937;
  margin: 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 장비 상태 뱃지 */
.monitoring-panel__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.monitoring-panel__status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.monitoring-panel__status--running {
  background: rgba(16, 185, 129, 0.08);
  color: #059669;
}

.monitoring-panel__status--running .monitoring-panel__status-dot {
  background: #10B981;
  box-shadow: 0 0 6px rgba(16, 185, 129, 0.4);
  animation: mp-dot-pulse 2s infinite;
}

@keyframes mp-dot-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.monitoring-panel__status--stopped {
  background: rgba(107, 114, 128, 0.08);
  color: #6B7280;
}

.monitoring-panel__status--stopped .monitoring-panel__status-dot {
  background: #9CA3AF;
}

.monitoring-panel__status--warning {
  background: rgba(245, 158, 11, 0.08);
  color: #D97706;
}

.monitoring-panel__status--warning .monitoring-panel__status-dot {
  background: #F59E0B;
  animation: mp-dot-pulse 1.5s infinite;
}

.monitoring-panel__status--alarm {
  background: rgba(239, 68, 68, 0.08);
  color: #DC2626;
}

.monitoring-panel__status--alarm .monitoring-panel__status-dot {
  background: #EF4444;
  animation: mp-dot-pulse 1s infinite;
}

/* 2026.02.12 : 박은정 : 장비 설명 영역 제거 (우측 학습 패널에서 제공하므로 중복 해소) */

/* 스크롤 가능한 본문 */
.monitoring-panel__body {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  /* 2026.02.12 : 박은정 : 상단 padding 추가 */
  padding: 16px 16px 24px;
}

/* 2025.02.11 : 박은정 : 아코디언 카드 리스트 (학습 시나리오와 동일한 스타일) */
.monitoring-panel__cards-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* 2026.02.11 : 박은정 : 플레이백 패널 컨테이너 (푸터 위쪽에 고정) */
.playback-panel-container {
  position: fixed;
  bottom: 80px; /* 푸터 높이만큼 위로 */
  left: 50%;
  transform: translateX(-50%);
  z-index: 99; /* 푸터(z-index: 100)보다 낮게 */
  width: 90%;
  max-width: 800px;
  padding: 0 20px;
}

/* 2026.02.11 : 박은정 : 플레이백 패널 스타일 */
.playback-panel {
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #F3F4F6;
  box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

/* 2026.02.12 : 박은정 : 헤더 (시나리오명 + 현재 단계 뱃지 + 자세히 보기 토글) */
.playback-panel__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-bottom: 1px solid #F3F4F6;
  background: #FAFBFC;
}

.playback-panel__title {
  font-size: 13px;
  font-weight: 600;
  color: #1F2937;
  margin: 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  white-space: nowrap;
}

/* 2026.02.12 : 박은정 : 현재 활성 단계 뱃지 */
.playback-panel__phase-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 400;
  color: #ffffff;
  white-space: nowrap;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  line-height: 1.4;
  transition: background-color 0.3s ease;
}

/* 2026.02.12 : 박은정 : 트랙 자세히 보기 / 접기 토글 버튼 */
.playback-panel__toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: auto;
  padding: 3px 10px;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  background: #ffffff;
  color: #6B7280;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  flex-shrink: 0;
}

.playback-panel__toggle-btn:hover {
  background: #F9FAFB;
  border-color: #D1D5DB;
  color: #374151;
}

.playback-panel__toggle-text {
  line-height: 1;
}

.playback-panel__toggle-icon {
  transition: transform 0.2s ease;
}

.playback-panel__toggle-icon--expanded {
  transform: rotate(180deg);
}

.playback-panel__content {
  padding: 12px 16px;
}

/* 2026.02.12 : 박은정 : 플레이백 컨트롤 스타일 — 고정 레이아웃 (flex-wrap 제거), 일관된 크기 */
.playback-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

/* 2026.02.12 : 박은정 : 재생/일시정지/정지 버튼 3개 분리 */
.playback-controls__buttons {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.playback-controls__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  background: #ffffff;
  color: #6B7280;
  cursor: pointer;
  transition: all 0.15s ease;
  padding: 0;
}

.playback-controls__btn:hover:not(:disabled) {
  background: #F9FAFB;
  border-color: #D1D5DB;
  color: #1F2937;
}

.playback-controls__btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.playback-controls__btn--play {
  color: #3B82F6;
}

.playback-controls__btn--play:hover:not(:disabled) {
  background: #EFF6FF;
  border-color: #93C5FD;
}

.playback-controls__btn--pause {
  color: #F59E0B;
}

.playback-controls__btn--pause:hover:not(:disabled) {
  background: #FFFBEB;
  border-color: #FCD34D;
}

.playback-controls__btn--stop {
  color: #EF4444;
}

.playback-controls__btn--stop:hover:not(:disabled) {
  background: #FEF2F2;
  border-color: #FCA5A5;
}

/* 2026.02.12 : 박은정 : 시간 표시 — 고정 폭 */
.playback-controls__time {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 12px;
  font-weight: 500;
  color: #1F2937;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  min-width: 88px;
  flex-shrink: 0;
}

.playback-controls__time-current {
  color: #3B82F6;
  font-variant-numeric: tabular-nums;
}

.playback-controls__time-separator {
  color: #9CA3AF;
}

.playback-controls__time-total {
  color: #6B7280;
  font-variant-numeric: tabular-nums;
}

/* 2026.02.12 : 박은정 : 시크바 영역 (단계 스트립 + 시크바를 감싸는 래퍼) */
.playback-controls__seek-area {
  flex: 1;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

/* 2026.02.12 : 박은정 : 재생바 상단 단계 표시 스트립 */
/* 2026.02.13 : 박은정 : 높이 16px → 22px로 확대하여 단계 텍스트 가독성 향상 */
.playback-controls__phase-strip {
  position: relative;
  height: 22px;
  border-radius: 3px;
  overflow: hidden;
  background: #F3F4F6;
}

.playback-controls__phase-segment {
  position: absolute;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  opacity: 0.65;
  transition: opacity 0.15s ease;
}

.playback-controls__phase-segment:hover {
  opacity: 0.9;
}

/* 2026.02.13 : 박은정 : 현재 활성 단계 하이라이트 (불투명도 + 테두리 + 그림자) */
.playback-controls__phase-segment--active {
  opacity: 1;
  box-shadow: 0 0 0 1.5px #ffffff, 0 0 6px rgba(0, 0, 0, 0.25);
  z-index: 1;
}

.playback-controls__phase-segment--active .playback-controls__phase-segment-text {
  font-weight: 400;
}

/* 2026.02.13 : 박은정 : 텍스트 크기 9px → 11px, text-shadow 강화하여 가독성 향상 */
.playback-controls__phase-segment-text {
  font-size: 11px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 4px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  line-height: 1;
}

/* 2026.02.12 : 박은정 : 시크바 — seek-area 내부 (색상을 현재 단계에 맞게 변경) */
.playback-controls__seek {
  position: relative;
  height: 6px;
  background: #F3F4F6;
  border-radius: 3px;
  cursor: pointer;
}

.playback-controls__seek-slider {
  position: absolute;
  top: -4px;
  left: 0;
  width: 100%;
  height: 14px;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
}

.playback-controls__seek-progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 3px;
  pointer-events: none;
  z-index: 1;
  transition: width 0.1s linear, background-color 0.3s ease;
}

/* 2026.02.12 : 박은정 : 재생 속도 — 라벨 제거, 콤팩트 */
.playback-controls__speed {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.playback-controls__speed-select {
  padding: 3px 6px;
  border: 1px solid #E5E7EB;
  border-radius: 5px;
  font-size: 11px;
  color: #1F2937;
  background: #ffffff;
  cursor: pointer;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.playback-controls__speed-select:hover {
  border-color: #D1D5DB;
}

/* 2026.02.12 : 박은정 : 플레이백 트랙 — 레이블 + 타임라인 2열 레이아웃, 고정 크기 */
.playback-track {
  display: flex;
  background: #FAFBFC;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  overflow: hidden;
}

/* 2026.02.12 : 박은정 : 레이블 열 (좌측 고정 64px) */
.playback-track__labels {
  display: flex;
  flex-direction: column;
  width: 64px;
  flex-shrink: 0;
  border-right: 1px solid #E5E7EB;
  background: #F9FAFB;
}

.playback-track__label {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 6px;
  font-size: 9px;
  font-weight: 600;
  color: #6B7280;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.playback-track__label--phase {
  height: 22px;
  font-size: 9px;
  font-weight: 500;
  color: #9CA3AF;
  border-bottom: 1px solid #E5E7EB;
}

.playback-track__label--state {
  height: 16px;
  border-bottom: 1px solid #F3F4F6;
}

.playback-track__label--state:last-child {
  border-bottom: none;
}

/* 2026.02.12 : 박은정 : 센서 라벨 (제어 라벨과 동일 높이, 색상만 다름) */
.playback-track__label--sensor {
  height: 16px;
  border-bottom: 1px solid #F3F4F6;
  color: #9CA3AF;
  font-size: 8px;
}

.playback-track__label--sensor:last-child {
  border-bottom: none;
}

/* 2026.02.12 : 박은정 : 제어/센서 섹션 헤더 (레이블 열 내) */
.playback-track__section-header {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 14px;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.5px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
  border-bottom: 1px solid #E5E7EB;
  border-top: 1px solid #E5E7EB;
}

.playback-track__section-header--control {
  color: #3B82F6;
  background: #EFF6FF;
}

.playback-track__section-header--sensor {
  color: #F59E0B;
  background: #FFFBEB;
}

/* 2026.02.12 : 박은정 : 타임라인 열 (우측, 나머지 영역) */
.playback-track__timeline {
  position: relative;
  flex: 1;
  cursor: pointer;
}

/* 2026.02.12 : 박은정 : Phase 구간 행 — 컴팩트 (22px) + 텍스트 라벨 */
.playback-track__phases-row {
  position: relative;
  height: 22px;
  border-bottom: 1px solid #E5E7EB;
}

.playback-track__phase {
  position: absolute;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  opacity: 0.85;
}

.playback-track__phase-text {
  font-size: 10px;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 4px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 2026.02.12 : 박은정 : 제어/센서 섹션 구분선 (타임라인 측, 레이블 섹션 헤더와 높이 일치) */
.playback-track__section-divider {
  height: 14px;
  border-bottom: 1px solid #E5E7EB;
  border-top: 1px solid #E5E7EB;
  background: #F9FAFB;
}

/* 2026.02.12 : 박은정 : 제어 상태 변화 행 (ON/OFF 사각형) */
.playback-track__state-row {
  position: relative;
  height: 16px;
  border-bottom: 1px solid #F3F4F6;
  background: #FDFDFE;
}

.playback-track__state-row:last-child {
  border-bottom: none;
}

/* 2026.02.12 : 박은정 : 센서 행 (제어 행보다 약간 밝은 배경) */
.playback-track__sensor-row {
  background: #FEFEFE;
}

.playback-track__state-range {
  position: absolute;
  top: 2px;
  bottom: 2px;
  border-radius: 2px;
  opacity: 0.55;
  transition: opacity 0.15s ease;
  overflow: hidden;
}

.playback-track__state-range:hover {
  opacity: 0.85;
}

/* 2026.02.12 : 박은정 : 센서 구간 사각형 (패턴으로 제어와 시각적 구분) */
.playback-track__sensor-range {
  opacity: 0.45;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.playback-track__sensor-range:hover {
  opacity: 0.75;
}

/* 2026.02.12 : 박은정 : 제어 변경점 마커 (ON 구간 내 수치 값 변경 위치를 흰색 세로선으로 표시) */
.playback-track__change-marker {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  background: rgba(255, 255, 255, 0.85);
  z-index: 2;
  pointer-events: auto;
  cursor: help;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.25);
}

.playback-track__change-marker::before {
  content: '';
  position: absolute;
  top: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-top: 3px solid rgba(255, 255, 255, 0.95);
}

/* 2026.02.12 : 박은정 : 재생 인디케이터 — 타임라인 전체 높이 관통 */
.playback-track__indicator {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #EF4444;
  z-index: 6;
  pointer-events: none;
  box-shadow: 0 0 4px rgba(239, 68, 68, 0.4);
}

.playback-track__indicator::before {
  content: '';
  position: absolute;
  top: -3px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #EF4444;
}

.monitoring-panel__body::-webkit-scrollbar {
  width: 4px;
}

.monitoring-panel__body::-webkit-scrollbar-track {
  background: transparent;
}

.monitoring-panel__body::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 2px;
}

/* 2025.02.11 : 박은정 : 아코디언 카드 (학습 시나리오와 동일한 스타일) */
.monitoring-panel__card {
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #F3F4F6;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
  margin-bottom: 8px;
}

.monitoring-panel__card:last-child {
  margin-bottom: 0;
}

.monitoring-panel__card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* 활성 카드 강조 */
.monitoring-panel__card--active {
  border-color: #3B82F6;
  box-shadow: 0 2px 12px rgba(59, 130, 246, 0.08);
}

/* 카드 헤더 */
.monitoring-panel__card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  cursor: pointer;
  background: #ffffff;
  transition: background 0.15s ease;
  user-select: none;
}

.monitoring-panel__card-header:hover {
  background: #FAFBFC;
}

.monitoring-panel__card-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.monitoring-panel__card-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
  background: #F3F4F6;
  color: #6B7280;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.monitoring-panel__card-number--active {
  background: #3B82F6;
  color: #ffffff;
}

.monitoring-panel__card-title {
  font-size: 14px;
  font-weight: 500;
  color: #1F2937;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.monitoring-panel__card-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.monitoring-panel__card-status {
  font-size: 11px;
  font-weight: 500;
  color: #9CA3AF;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.monitoring-panel__card-chevron {
  color: #9CA3AF;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.monitoring-panel__card-chevron--open {
  transform: rotate(180deg);
}

/* 아코디언 본문 (펼침/접힘) */
.monitoring-panel__card-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.monitoring-panel__card-content--open {
  max-height: 2000px; /* 충분히 큰 값 */
}

.monitoring-panel__card-body {
  padding: 0 16px 16px;
}

/* 제어 장비 목록 */
.monitoring-panel__devices {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* 제어 장비 카드 */
.mp-device {
  background: #F9FAFB;
  border-radius: 12px;
  padding: 12px 14px;
  border: 1px solid #F3F4F6;
  transition: border-color 0.2s ease;
}

.mp-device:hover {
  border-color: #E5E7EB;
}

.mp-device__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.mp-device__info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mp-device__id {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.mp-device__name {
  font-size: 12px;
  color: #6B7280;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 장비 상태 뱃지 (개별 장비) */
.mp-device__status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.mp-device__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.mp-device__status--running {
  background: rgba(16, 185, 129, 0.08);
  color: #059669;
}

.mp-device__status--running .mp-device__status-dot {
  background: #10B981;
}

.mp-device__status--stopped {
  background: rgba(107, 114, 128, 0.08);
  color: #6B7280;
}

.mp-device__status--stopped .mp-device__status-dot {
  background: #9CA3AF;
}

.mp-device__status--warning {
  background: rgba(245, 158, 11, 0.08);
  color: #D97706;
}

.mp-device__status--warning .mp-device__status-dot {
  background: #F59E0B;
}

.mp-device__role {
  font-size: 11px;
  color: #9CA3AF;
  margin-bottom: 6px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 제어 포인트 목록 */
.mp-device__controls {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid #F3F4F6;
}

.mp-ctrl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
}

.mp-ctrl__left {
  display: flex;
  align-items: center;
  gap: 6px;
}

.mp-ctrl__type {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  padding: 1px 4px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  background: rgba(99, 102, 241, 0.08);
  color: #6366F1;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.mp-ctrl__name {
  font-size: 12px;
  color: #4B5563;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.mp-ctrl__right {
  display: flex;
  align-items: center;
  gap: 4px;
}

.mp-ctrl__value {
  font-size: 12px;
  font-weight: 600;
  color: #1F2937;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.mp-ctrl__unit {
  font-size: 11px;
  color: #9CA3AF;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 모니터링 센서 섹션 */
.monitoring-panel__sections {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mp-section {
  background: #F9FAFB;
  border-radius: 12px;
  padding: 12px 14px;
  border: 1px solid #F3F4F6;
}

.mp-section__title {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.mp-section__rows {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* 모니터링 데이터 행 */
.mp-data-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  background: #ffffff;
  border-radius: 8px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.mp-data-row__left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mp-data-row__indicator {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.mp-data-row__indicator--normal {
  background: #10B981;
}

.mp-data-row__indicator--warning {
  background: #F59E0B;
}

.mp-data-row__indicator--alarm {
  background: #EF4444;
}

.mp-data-row__labels {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.mp-data-row__id {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.mp-data-row__desc {
  font-size: 11px;
  color: #9CA3AF;
}

.mp-data-row__right {
  display: flex;
  align-items: baseline;
  gap: 3px;
}

.mp-data-row__value {
  font-size: 14px;
  font-weight: 600;
  color: #1F2937;
}

.mp-data-row__unit {
  font-size: 11px;
  color: #9CA3AF;
  font-weight: 500;
}

/* ===========================================================================================
 * 2026.02.13 : 박은정 : P&ID 다이어그램 (PidDiagram) 스타일
 * Reference : packages/scjeil-smart_ict_lab-app/src/components/PidDiagram.tsx
 * =========================================================================================== */

/* P&ID SVG 컨테이너 */
.pid-diagram {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  background: #DFE3E8;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

/* P&ID 섹션 래퍼 (모니터링 패널 내) */
.monitoring-panel__pid {
  padding: 0 0 12px 0;
}

.monitoring-panel__pid-title {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 2026.05.13 : 박은정 : 시뮬레이션 값 변화 누적 그래프 (좌측 패널 컴팩트 버전) */
.playback-chart {
  padding: 8px;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.playback-chart__header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 4px;
  gap: 6px;
}

.playback-chart__title {
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  color: #374151;
}

.playback-chart__hint {
  font-size: 9px;
  color: #9ca3af;
  white-space: nowrap;
}

/* 2026.05.13 : 박은정 : 범례 chip 버튼 (다중 토글, 좁은 패널에 wrap) */
.playback-chart__legend {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  margin-top: 6px;
}

.playback-chart__chip {
  font-family: inherit;
  font-size: 9px;
  font-weight: 600;
  padding: 2px 6px;
  border: 1px solid;
  border-radius: 999px;
  cursor: pointer;
  line-height: 1.2;
  white-space: nowrap;
  transition: opacity 0.15s ease, background-color 0.15s ease, color 0.15s ease;
}

.playback-chart__chip:hover {
  opacity: 0.85;
}

.playback-chart__chip--off {
  opacity: 0.65;
}
`, "",{"version":3,"sources":["webpack://./src/main.css"],"names":[],"mappings":"AAAA;;;;;;;wFAOwF;;AAExF,sCAAsC;AACtC;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,oDAAoD;AACpD,kDAAkD;AAClD;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,UAAU;AACZ;;AAEA,yEAAyE;AACzE;EACE,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kDAAkD;AACpD;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,uDAAuD;AACzD;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,iFAAiF;EACjF,wBAAwB;AAC1B;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,iFAAiF;AACnF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,iFAAiF;AACnF;;AAEA,iDAAiD;AACjD;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,iFAAiF;AACnF;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iFAAiF;EACjF,qBAAqB;AACvB;;AAEA,wDAAwD;AACxD,wEAAwE;AACxE;EACE;IACE,gBAAgB;IAChB,oBAAoB;IACpB,iCAAiC;EACnC;EACA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,0EAA0E;AAC1E,0EAA0E;AAC1E;EACE;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,QAAQ;EACV;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,8BAA8B;EAC9B,0BAA0B;EAC1B,cAAc;EACd,0CAA0C;EAC1C,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6DAA6D;EAC7D,iFAAiF;EACjF,aAAa;EACb,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,kDAAkD;AAClD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;AACvC;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,yCAAyC;EACzC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8DAA8D;EAC9D,iFAAiF;EACjF,aAAa;EACb,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;EAC1B,iFAAiF;EACjF,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,qBAAqB;EACrB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA,qFAAqF;AACrF;EACE;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;IACf,4BAA4B;EAC9B;EACA;IACE,YAAY;IACZ,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,2GAA2G;AAC3G;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,iCAAiC;IACjC,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iFAAiF;EACnF;AACF;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uDAAuD;EACvD,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iFAAiF;AACnF;;AAEA,wDAAwD;AACxD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;EAC1B,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,OAAO,mBAAmB,IAAI,UAAU,EAAE;AAC5C;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,wEAAwE;EACxE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,2BAA2B;EAC3B,4BAA4B;EAC5B,2CAA2C;EAC3C,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,iFAAiF;AACnF;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA,2CAA2C;AAC3C,0EAA0E;AAC1E;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,qCAAqC;EACrC,0BAA0B;EAC1B,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,iFAAiF;EACjF,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iFAAiF;EACjF,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iFAAiF;EACjF,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE;IACE,eAAe;EACjB;EACA;IACE,QAAQ;IACR,YAAY;IACZ,OAAO;EACT;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA,0DAA0D;AAC1D;EACE;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,wDAAwD;EACxD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;;;gGAGgG;;AAEhG,0BAA0B;AAC1B;EACE,eAAe;EACf,SAAS,EAAE,UAAU;EACrB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,UAAU;EACV;gCAC8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,sBAAsB;EACtB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,iFAAiF;AACnF;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;iDAEiD;AACjD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,wDAAwD;AAC1D;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB,EAAE,yCAAyC;AAC/D;;AAEA;EACE,oBAAoB;AACtB;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;;iDAEiD;AACjD;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,iFAAiF;AACnF;;AAEA,QAAQ;AACR;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iFAAiF;AACnF;;AAEA,OAAO;AACP;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,cAAc;EACd,iFAAiF;AACnF;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA,mDAAmD;AACnD;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iFAAiF;AACnF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iFAAiF;EACjF,OAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,iFAAiF;AACnF;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,iFAAiF;AACnF;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,iFAAiF;EACjF,aAAa;EACb,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;gGAGgG;;AAEhG,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iFAAiF;AACnF;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,iFAAiF;EACjF,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,uFAAuF;EACvF,yCAAyC;AAC3C;;AAEA;EACE,qFAAqF;EACrF,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iFAAiF;AACnF;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,0BAA0B;EAC1B,iFAAiF;AACnF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,OAAO;AACP;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;EACrD,iFAAiF;EACjF,aAAa;EACb,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,iFAAiF;EACjF,aAAa;EACb,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;gGAGgG;;AAEhG,sCAAsC;AACtC;EACE,eAAe;EACf,SAAS,EAAE,UAAU;EACrB,OAAO;EACP,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,UAAU;EACV;gCAC8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,iFAAiF;AACnF;;AAEA,aAAa;AACb;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA,4DAA4D;;AAE5D,eAAe;AACf;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,YAAY,EAAE,eAAe;EAC7B,SAAS;EACT,2BAA2B;EAC3B,WAAW,EAAE,0BAA0B;EACvC,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,iFAAiF;EACjF,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iFAAiF;EACjF,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,4CAA4C;AAC5C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,iFAAiF;EACjF,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iFAAiF;EACjF,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA,qDAAqD;AACrD;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,wCAAwC;AACxC,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA,yDAAyD;AACzD;EACE,UAAU;EACV,4DAA4D;EAC5D,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,iFAAiF;EACjF,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,yDAAyD;AAC3D;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,qBAAqB;AACvB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iFAAiF;EACjF,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,iFAAiF;EACjF,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,OAAO;EACP,eAAe;AACjB;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,yCAAyC;EACzC,iFAAiF;AACnF;;AAEA,+DAA+D;AAC/D;EACE,YAAY;EACZ,gCAAgC;EAChC,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,UAAU;EACV,oBAAoB;EACpB,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB,EAAE,YAAY;AAClC;;AAEA;EACE,oBAAoB;AACtB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iFAAiF;AACnF;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iFAAiF;AACnF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iFAAiF;AACnF;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iFAAiF;AACnF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;gGAGgG;;AAEhG,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iFAAiF;AACnF;;AAEA,wDAAwD;AACxD;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6EAA6E;AAC/E;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":["/***************************************************************************************\n * FileName      : main.css\n * Description   : scjeil-smart_ict_lab-app 메인 스타일시트 (애니메이션, 레이아웃, 컴포넌트 스타일)\n * Author        : (주)한국공학기술연구원 박은정\n * Created Date  : 2026.02.03\n * Modified Date : 2026.02.20 헤더 타이틀 h1 주색 적용, 버전 표시 스타일, 순천제일대학교 텍스트 스타일 추가\n * Reference     : mockup/asset/css/main.css\n ***************************************************************************************/\n\n/* 2026.02.03 : 박은정 : 화면 전환 애니메이션 추가 */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n/* 2026.02.13 : 박은정 : 매터포트 공간 로딩 중 상태 표시 모달 스타일 추가 */\n/* 2026.02.20 : 박은정 : 헤더(48px) 아래부터 표시되도록 top 변경 */\n.loading-modal {\n  position: fixed;\n  top: 48px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto;\n  opacity: 0;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.loading-modal--visible {\n  opacity: 1;\n}\n\n.loading-modal__backdrop {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.3);\n  z-index: 1;\n}\n\n/* 2026.02.20 : 박은정 : 3D 공간 로딩 시 배경 이미지 스타일 (background-image로 다운로드 방지) */\n.loading-modal__backdrop--bg {\n  background-color: #1a1a2e;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  -webkit-user-select: none;\n  user-select: none;\n  -webkit-user-drag: none;\n  pointer-events: none;\n}\n\n/* 2026.02.20 : 박은정 : 로딩 표시 — 배경 없이 배경 이미지 위에 직접 표시 */\n.loading-modal__indicator {\n  position: relative;\n  z-index: 2;\n  text-align: center;\n  animation: loadingIndicatorFadeIn 0.6s ease-out;\n}\n\n@keyframes loadingIndicatorFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* 2026.02.20 : 박은정 : 스피너 크기 확대 (64px → 96px) */\n.loading-modal__spinner {\n  width: 96px;\n  height: 96px;\n  margin: 0 auto 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loading-modal__spinner-svg {\n  width: 100%;\n  height: 100%;\n  animation: loadingSpinnerRotate 1s linear infinite;\n}\n\n/* 2026.02.20 : 박은정 : 스피너 흰색 메인 + 진한 테두리 */\n.loading-modal__spinner-circle {\n  stroke: #FB6544;\n  stroke-linecap: round;\n  stroke-dasharray: 90, 150;\n  stroke-dashoffset: 0;\n  animation: loadingSpinnerDash 1.5s ease-in-out infinite;\n}\n\n@keyframes loadingSpinnerRotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingSpinnerDash {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124;\n  }\n}\n\n/* 2026.02.20 : 박은정 : 로딩 텍스트 흰색 + 진한 테두리 */\n.loading-modal__text {\n  font-size: 24px;\n  color: #FB6544;\n  -webkit-text-stroke: 3px #fff;\n  margin: 0;\n  font-weight: 700;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  paint-order: stroke fill;\n}\n\n/* 2026.02.09 : 박은정 : 타이틀 오버레이(Phase 2) 스타일 추가 */\n.title-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto;\n  opacity: 0;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.title-overlay--visible {\n  opacity: 1;\n}\n\n.title-overlay__backdrop {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.2);\n  z-index: 1;\n}\n\n.title-overlay__card {\n  position: relative;\n  z-index: 2;\n  background: #ffffff;\n  border-radius: 24px;\n  padding: 48px;\n  max-width: 630px;\n  width: 90%;\n  text-align: center;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n  animation: titleCardFadeInUp 0.6s ease-out;\n}\n\n@keyframes titleCardFadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.title-overlay__logo {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 24px;\n  background: linear-gradient(135deg, #3B82F6 0%, #1e40af 100%);\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.title-overlay__logo svg {\n  width: 48px;\n  height: 48px;\n  color: white;\n}\n\n.title-overlay__title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #3B82F6;\n  margin: 0 0 4px 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.title-overlay__subtitle {\n  font-size: 16px;\n  color: #6B7280;\n  margin: 0 0 24px 0;\n  font-weight: 400;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.title-overlay__divider {\n  width: 60px;\n  height: 2px;\n  background-color: #3B82F6;\n  margin: 0 auto 24px;\n}\n\n.title-overlay__description {\n  font-size: 15px;\n  color: #6B7280;\n  line-height: 1.6;\n  margin: 0 0 32px 0;\n  font-weight: 400;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.title-overlay__cta-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 48px;\n  background-color: #3B82F6;\n  color: #ffffff;\n  border: none;\n  border-radius: 9999px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 150ms ease;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.title-overlay__cta-btn:hover {\n  background-color: #2563EB;\n}\n\n.title-overlay__footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 16px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 2;\n}\n\n.title-overlay__footer-logos {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.title-overlay__footer-logo-item {\n  font-weight: 300;\n  color: #1F2937;\n  background: white;\n  padding: 10px 20px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  font-size: 14px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* 2026.02.25 : 박은정 : 타이틀 오버레이 하단 기관명 링크 스타일 추가 */\n.title-overlay__footer-logo-link {\n  text-decoration: none;\n}\n\n.title-overlay__footer-info {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.8);\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* 2026.02.13 : 박은정 : 타이틀 오버레이 카드 하단 버전 표시 스타일 추가 */\n.title-overlay__version {\n  margin-top: 16px;\n  font-size: 12px;\n  color: #C0C0C0;\n  font-weight: 400;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  letter-spacing: 0.3px;\n}\n\n/* 2026.05.15 : 박은정 : 모바일 가로/좁은 화면에서 타이틀 모달 위·아래 잘림 해결 */\n/* 2026.05.15 : 박은정 : 화면 가운데 정렬 + 가로 폭 축소 (margin:auto로 스크롤 시에도 안전 중앙) */\n@media (max-height: 600px), (max-width: 768px) {\n  .title-overlay {\n    overflow-y: auto;\n    padding: 16px 0 72px;\n    -webkit-overflow-scrolling: touch;\n  }\n  .title-overlay__card {\n    padding: 40px 24px 36px;\n    border-radius: 18px;\n    width: 88%;\n    max-width: 560px;\n    margin: auto;\n  }\n  .title-overlay__logo {\n    width: 56px;\n    height: 56px;\n    margin: 0 auto 20px;\n    border-radius: 14px;\n  }\n  .title-overlay__logo svg {\n    width: 32px;\n    height: 32px;\n  }\n  .title-overlay__title {\n    font-size: 20px;\n    margin: 0 0 8px 0;\n  }\n  .title-overlay__subtitle {\n    font-size: 13px;\n    margin: 0 0 22px 0;\n  }\n  .title-overlay__divider {\n    margin: 0 auto 22px;\n  }\n  .title-overlay__description {\n    font-size: 13px;\n    margin: 0 0 28px 0;\n  }\n  .title-overlay__description br {\n    display: none;\n  }\n  .title-overlay__cta-btn {\n    padding: 12px 32px;\n    font-size: 14px;\n  }\n  .title-overlay__version {\n    margin-top: 18px;\n    font-size: 11px;\n  }\n  .title-overlay__footer {\n    padding: 8px 12px;\n  }\n  .title-overlay__footer-logos {\n    gap: 8px;\n  }\n  .title-overlay__footer-logo-item {\n    padding: 6px 10px;\n    font-size: 11px;\n  }\n}\n\n/* 2026.05.15 : 박은정 : 모바일 가로(≤450px 높이)에서 타이틀 모달 추가 축소 — 스크롤 없이 한 화면에 표시 */\n/* 2026.05.15 : 박은정 : min-height + flex-column 으로 카드가 뷰포트 세로를 충분히 채우도록 함 */\n@media (max-height: 450px) {\n  .title-overlay {\n    padding: 8px 0 40px;\n  }\n  .title-overlay__card {\n    padding: 22px 28px 20px;\n    max-width: 520px;\n    min-height: calc(100vh - 100px);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n  .title-overlay__logo {\n    width: 48px;\n    height: 48px;\n    margin: 0 auto 12px;\n    border-radius: 12px;\n  }\n  .title-overlay__logo svg {\n    width: 28px;\n    height: 28px;\n  }\n  .title-overlay__title {\n    font-size: 17px;\n    margin: 0 0 6px 0;\n  }\n  .title-overlay__subtitle {\n    font-size: 12px;\n    margin: 0 0 14px 0;\n  }\n  .title-overlay__divider {\n    margin: 0 auto 14px;\n    width: 44px;\n  }\n  .title-overlay__description {\n    font-size: 12px;\n    line-height: 1.45;\n    margin: 0 0 18px 0;\n  }\n  .title-overlay__cta-btn {\n    padding: 10px 28px;\n    font-size: 13px;\n  }\n  .title-overlay__version {\n    margin-top: 12px;\n    font-size: 10px;\n  }\n  .title-overlay__footer {\n    padding: 5px 12px;\n  }\n  .title-overlay__footer-logos {\n    gap: 6px;\n  }\n  .title-overlay__footer-logo-item {\n    padding: 5px 9px;\n    font-size: 10px;\n  }\n}\n\n/* 2026.02.12 : 박은정 : 진입 애니메이션 오버레이 (건너뛰기 버튼) */\n.intro-anim-overlay {\n  position: fixed;\n  bottom: 40px;\n  right: 40px;\n  z-index: 10001;\n  animation: introAnimOverlayFadeIn 0.5s ease-out;\n}\n\n@keyframes introAnimOverlayFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.intro-anim-overlay__skip-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(8px);\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 9999px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 150ms ease, transform 150ms ease;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.intro-anim-overlay__skip-btn:hover {\n  background: rgba(0, 0, 0, 0.8);\n  transform: scale(1.05);\n}\n\n/* 2026.02.09 : 박은정 : 장비 학습하기 모달 + 학습현황 사이드바 스타일 */\n.eq-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.25s ease, visibility 0.25s ease;\n}\n\n.eq-modal--visible {\n  opacity: 1;\n  visibility: visible;\n}\n\n.eq-modal__backdrop {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.35);\n}\n\n/* 2026.02.09 : 박은정 : 모달 + 사이드바 가로 배치 래퍼 */\n.eq-modal__layout {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  max-height: 85vh;\n  animation: eqModalFadeIn 0.3s ease-out;\n}\n\n@keyframes eqModalFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(16px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.eq-modal__card {\n  position: relative;\n  background: #ffffff;\n  border-radius: 24px 0 0 24px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n  width: 400px;\n  max-width: 50vw;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* 2026.02.09 : 박은정 : 학습현황 사이드바 패널 (모달 오른쪽) */\n.eq-modal__sidebar {\n  position: relative;\n  background: #F9FAFB;\n  border-radius: 0 24px 24px 0;\n  width: 260px;\n  max-width: 35vw;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow-y: auto;\n  border-left: 1px solid #F3F4F6;\n}\n\n.eq-modal__sidebar-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.eq-modal__sidebar-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1F2937;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.eq-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid #F3F4F6;\n}\n\n.eq-modal__header-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.eq-modal__name {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1F2937;\n  margin: 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.eq-modal__name-en {\n  font-size: 12px;\n  color: #9CA3AF;\n  font-weight: 400;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.eq-modal__close {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  cursor: pointer;\n  color: #9CA3AF;\n  background: rgba(0, 0, 0, 0.04);\n  border: none;\n  transition: all 150ms ease;\n}\n\n.eq-modal__close:hover {\n  background: rgba(0, 0, 0, 0.08);\n  color: #1F2937;\n}\n\n.eq-modal__body {\n  padding: 20px 24px;\n  overflow-y: auto;\n}\n\n.eq-modal__desc {\n  font-size: 14px;\n  color: #6B7280;\n  line-height: 1.6;\n  margin: 0 0 16px 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.eq-modal__specs {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: #F9FAFB;\n  border-radius: 12px;\n  padding: 12px 16px;\n}\n\n.eq-modal__spec-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 13px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.eq-modal__spec-label {\n  color: #9CA3AF;\n  font-weight: 400;\n}\n\n.eq-modal__spec-value {\n  color: #1F2937;\n  font-weight: 500;\n}\n\n.eq-modal__footer {\n  padding: 16px 24px 20px;\n  border-top: 1px solid #F3F4F6;\n}\n\n/* 2026.02.09 : 박은정 : 버튼 2개 (이어서 학습하기 + 학습하기) 가로 배치 */\n.eq-modal__footer--dual {\n  display: flex;\n  gap: 8px;\n}\n\n.eq-modal__learn-btn {\n  display: block;\n  width: 100%;\n  padding: 14px;\n  border: none;\n  border-radius: 14px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 150ms ease, box-shadow 150ms ease;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n/* 이어서 학습하기 (보조 버튼 — 아웃라인 스타일) */\n.eq-modal__learn-btn--resume {\n  background: #ffffff;\n  color: #3B82F6;\n  border: 1.5px solid #3B82F6;\n}\n\n.eq-modal__learn-btn--resume:hover {\n  background: rgba(59, 130, 246, 0.06);\n}\n\n/* 학습하기 (주 버튼 — 채움 스타일) */\n.eq-modal__learn-btn--start {\n  background-color: #3B82F6;\n  color: #ffffff;\n}\n\n.eq-modal__learn-btn--start:hover {\n  background-color: #2563EB;\n}\n\n/* 2026.02.09 : 박은정 : 모달 내 학습 진행률 바 스타일 추가 */\n.eq-modal__progress {\n  margin-top: 16px;\n}\n\n.eq-modal__progress-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n\n.eq-modal__progress-title {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6B7280;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.eq-modal__progress-value {\n  font-size: 12px;\n  font-weight: 600;\n  color: #3B82F6;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.eq-modal__progress-bar {\n  width: 100%;\n  height: 6px;\n  background: #F3F4F6;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.eq-modal__progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #3B82F6, #60A5FA);\n  border-radius: 3px;\n  transition: width 0.4s ease;\n}\n\n/* 2026.02.09 : 박은정 : 사이드바 학습카드 체크리스트 스타일 (세로 목록) */\n.eq-modal__checklist {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.eq-modal__checklist-hint {\n  font-size: 11px;\n  color: #9CA3AF;\n  margin-bottom: 2px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.eq-modal__checklist-items {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n/* 2026.02.09 : 박은정 : 카드 버튼 - 세로 리스트 아이템 스타일 */\n.eq-modal__check-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1.5px solid transparent;\n  cursor: pointer;\n  transition: all 150ms ease;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  text-align: left;\n  line-height: 1;\n}\n\n.eq-modal__check-item:hover {\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n}\n\n.eq-modal__check-item--pending {\n  background: #ffffff;\n  color: #9CA3AF;\n}\n\n.eq-modal__check-item--in-progress {\n  background: rgba(59, 130, 246, 0.06);\n  color: #3B82F6;\n}\n\n.eq-modal__check-item--completed {\n  background: rgba(16, 185, 129, 0.06);\n  color: #10B981;\n}\n\n/* 2026.02.09 : 박은정 : 선택된 카드 강조 스타일 */\n.eq-modal__check-item--selected {\n  border-color: #3B82F6;\n  background: rgba(59, 130, 246, 0.08);\n  color: #2563EB;\n}\n\n.eq-modal__check-item--selected.eq-modal__check-item--completed {\n  border-color: #10B981;\n  background: rgba(16, 185, 129, 0.08);\n  color: #059669;\n}\n\n/* 2026.02.09 : 박은정 : 카드 번호 (사이드바 리스트 순번) */\n.eq-modal__check-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  background: rgba(0, 0, 0, 0.05);\n  color: inherit;\n  flex-shrink: 0;\n}\n\n.eq-modal__check-item--selected .eq-modal__check-num {\n  background: #3B82F6;\n  color: #ffffff;\n}\n\n.eq-modal__check-item--selected.eq-modal__check-item--completed .eq-modal__check-num {\n  background: #10B981;\n  color: #ffffff;\n}\n\n.eq-modal__check-label {\n  flex: 1;\n  line-height: 1;\n}\n\n.eq-modal__check-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n/* 2026.05.15 : 박은정 : 모바일 가로/좁은 화면에서 학습 모달이 잘리지 않도록 padding/font 축소 + max-height 확대 */\n@media (max-height: 600px), (max-width: 768px) {\n  .eq-modal__layout {\n    max-height: 94vh;\n    width: auto;\n    max-width: 92vw;\n  }\n  .eq-modal__card {\n    width: 360px;\n    max-width: 54vw;\n    border-radius: 16px 0 0 16px;\n  }\n  .eq-modal__sidebar {\n    width: 220px;\n    max-width: 36vw;\n    border-radius: 0 16px 16px 0;\n    padding: 12px 14px;\n    gap: 10px;\n  }\n  .eq-modal__sidebar-title {\n    font-size: 13px;\n  }\n  .eq-modal__header {\n    padding: 12px 16px;\n  }\n  .eq-modal__name {\n    font-size: 15px;\n  }\n  .eq-modal__name-en {\n    font-size: 11px;\n  }\n  .eq-modal__close {\n    width: 28px;\n    height: 28px;\n  }\n  .eq-modal__body {\n    padding: 12px 16px;\n  }\n  .eq-modal__desc {\n    font-size: 12px;\n    line-height: 1.5;\n    margin: 0 0 10px 0;\n  }\n  .eq-modal__specs {\n    padding: 8px 12px;\n    gap: 6px;\n  }\n  .eq-modal__spec-row {\n    font-size: 12px;\n  }\n  .eq-modal__footer {\n    padding: 10px 16px 12px;\n  }\n  .eq-modal__learn-btn {\n    padding: 10px;\n    font-size: 13px;\n    border-radius: 12px;\n  }\n  .eq-modal__progress {\n    margin-top: 8px;\n  }\n  .eq-modal__progress-title,\n  .eq-modal__progress-value {\n    font-size: 11px;\n  }\n  .eq-modal__check-item {\n    padding: 6px 8px;\n    font-size: 12px;\n    gap: 6px;\n  }\n  .eq-modal__check-num {\n    width: 18px;\n    height: 18px;\n    font-size: 11px;\n  }\n}\n\n/* 2026.05.15 : 박은정 : 모바일 세로(≤768px) 및 모바일 가로(≤600px 높이)에서는 학습현황 사이드바 숨기고 카드만 표시 + 학습 버튼 대신 \"PC 버전 안내\" 문구 */\n@media (max-width: 768px), (max-height: 600px) {\n  .eq-modal__sidebar {\n    display: none;\n  }\n  .eq-modal__card {\n    width: 88vw;\n    max-width: 480px;\n    border-radius: 18px;\n  }\n  .eq-modal__footer .eq-modal__learn-btn {\n    display: none;\n  }\n  .eq-modal__footer::after {\n    content: '학습은 PC 웹 브라우저로 진행해 주세요';\n    display: block;\n    text-align: center;\n    color: #6B7280;\n    font-size: 13px;\n    font-weight: 500;\n    padding: 12px;\n    background: #F9FAFB;\n    border-radius: 12px;\n    font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  }\n}\n\n/* 2026.02.20 : 박은정 : 학습 패널 개요 카드 — 장비 설명 이미지 썸네일 스타일 */\n.lp-overview-thumb-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 16px;\n  cursor: pointer;\n}\n\n.lp-overview-thumb {\n  width: 100%;\n  max-height: 180px;\n  object-fit: contain;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  background: #F9FAFB;\n  transition: transform 150ms ease, box-shadow 150ms ease;\n  padding: 3px;\n}\n\n.lp-overview-thumb:hover {\n  transform: scale(1.02);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.lp-overview-thumb-hint {\n  font-size: 11px;\n  color: #9CA3AF;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* 2026.02.20 : 박은정 : 학습 패널 개요 카드 — 이미지 팝업 (라이트박스) 스타일 */\n.lp-lightbox {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(4px);\n  animation: lpLightboxFadeIn 0.2s ease-out;\n  cursor: pointer;\n}\n\n@keyframes lpLightboxFadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n.lp-lightbox__close {\n  position: absolute;\n  top: 24px;\n  right: 24px;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  border: none;\n  background: rgba(255, 255, 255, 0.15);\n  color: #ffffff;\n  cursor: pointer;\n  transition: background 150ms ease;\n}\n\n.lp-lightbox__close:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.lp-lightbox__img {\n  max-width: 85vw;\n  max-height: 85vh;\n  object-fit: contain;\n  border-radius: 12px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);\n  cursor: default;\n  animation: lpLightboxZoomIn 0.25s ease-out;\n}\n\n@keyframes lpLightboxZoomIn {\n  from { transform: scale(0.9); opacity: 0; }\n  to   { transform: scale(1);   opacity: 1; }\n}\n\n/* 2026.02.09 : 박은정 : 하단 장비 선택 탭 바 스타일 추가 (Phase 3) */\n.eq-footer {\n  position: fixed;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 100;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.4s ease, visibility 0.4s ease, transform 0.4s ease;\n  transform: translateX(-50%) translateY(20px);\n}\n\n.eq-footer--visible {\n  opacity: 1;\n  visibility: visible;\n  transform: translateX(-50%) translateY(0);\n}\n\n.eq-footer__tabs {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(12px);\n  border-radius: 16px 16px 0 0;\n  box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(229, 231, 235, 0.6);\n  border-bottom: none;\n}\n\n.eq-footer__tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border-radius: 10px;\n  border: 1.5px solid transparent;\n  background: #F3F4F6;\n  color: #6B7280;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 150ms ease;\n  white-space: nowrap;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.eq-footer__tab:hover:not(:disabled) {\n  background: #E8EDF3;\n  color: #1F2937;\n}\n\n.eq-footer__tab--active {\n  background: rgba(59, 130, 246, 0.08);\n  color: #3B82F6;\n  border-color: #3B82F6;\n}\n\n.eq-footer__tab--active:hover {\n  background: rgba(59, 130, 246, 0.12);\n  color: #3B82F6;\n}\n\n.eq-footer__tab--disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.eq-footer__tab-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: inherit;\n  flex-shrink: 0;\n}\n\n.eq-footer__tab-label {\n  color: inherit;\n  line-height: 1;\n}\n\n/* 2026.02.09 : 박은정 : 장비 탭 진행률 뱃지 스타일 추가 */\n.eq-footer__tab-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 1px 6px;\n  border-radius: 8px;\n  line-height: 1.4;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.eq-footer__tab-badge--progress {\n  background: rgba(59, 130, 246, 0.12);\n  color: #3B82F6;\n}\n\n.eq-footer__tab-badge--complete {\n  background: rgba(16, 185, 129, 0.12);\n  color: #10B981;\n}\n\n.eq-footer__divider {\n  width: 1px;\n  height: 24px;\n  background: #E5E7EB;\n  margin: 0 4px;\n  flex-shrink: 0;\n}\n\n/* 2026.02.09 : 박은정 : 상단 헤더 바 스타일 (항상 표시) */\n/* 2026.02.20 : 박은정 : 좌측(타이틀+버전) / 우측(순천제일대학교) 배치를 위해 justify-content 추가 */\n.app-header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 48px;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid rgba(229, 231, 235, 0.6);\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n}\n\n/* 2026.02.20 : 박은정 : 헤더 좌측 영역 (타이틀 + 버전) 하단 정렬 */\n.app-header__left {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n/* 2026.02.20 : 박은정 : h1 태그로 변경, 프로젝트 주색(#3B82F6) 적용 */\n.app-header__title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #3B82F6;\n  letter-spacing: -0.2px;\n  margin: 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  white-space: nowrap;\n}\n\n/* 2026.02.20 : 박은정 : 버전 표시 (타이틀 모달 버전 색상 #C0C0C0 동일 적용, h1보다 작은 글자 크기) */\n.app-header__version {\n  font-size: 12px;\n  font-weight: 300;\n  color: #C0C0C0;\n  letter-spacing: 0.3px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  white-space: nowrap;\n}\n\n/* 2026.02.20 : 박은정 : 헤더 우측 순천제일대학교 텍스트 */\n.app-header__university {\n  font-size: 18px;\n  font-weight: 700;\n  color: #3B82F6;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  white-space: nowrap;\n}\n\n/* 2026.05.15 : 박은정 : 모바일 세로 화면(태블릿 이하)에서 헤더 글씨 줄바뀜 방지 */\n@media (max-width: 768px) {\n  .app-header {\n    padding: 0 12px;\n  }\n  .app-header__left {\n    gap: 6px;\n    min-width: 0;\n    flex: 1;\n  }\n  .app-header__title {\n    font-size: 13px;\n    letter-spacing: -0.3px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  .app-header__version {\n    font-size: 10px;\n  }\n  .app-header__university {\n    font-size: 13px;\n    flex-shrink: 0;\n  }\n}\n\n/* 2026.05.15 : 박은정 : 휴대폰 세로(≤480px)에서는 university 표기 축약 */\n@media (max-width: 480px) {\n  .app-header__title {\n    font-size: 12px;\n  }\n  .app-header__version {\n    display: none;\n  }\n  .app-header__university {\n    font-size: 12px;\n  }\n}\n\n.frame {\n  height: 100%;\n  width: 100%;\n  border-width: 0px;\n  /* 2026.02.09 : 박은정 : 오버레이가 iframe 위에 표시되도록 z-index 설정 */\n  position: relative;\n  z-index: 1;\n}\n\n.main {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  /* 2026.02.09 : 박은정 : 헤더 높이만큼 상단 여백 */\n  padding-top: 48px;\n  box-sizing: border-box;\n}\n\n.video-controls-wrapper {\n  z-index: 100;\n  position: fixed;\n  right: 10px;\n  top: 10px;\n  float: right;\n  width: 200px;\n  background-color: rgba(255, 255, 255, 0.9);\n  border-radius: 8px;\n  padding: 15px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n}\n\n.video-controls h3 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 16px;\n}\n\n.video-controls button {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 10px;\n  border: none;\n  border-radius: 5px;\n  background-color: #007bff;\n  color: white;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.video-controls button:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.video-controls button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n.video-status {\n  margin-top: 10px;\n  padding: 8px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #666;\n}\n\n.video-status p {\n  margin: 0;\n}\n\n/* ===========================================================================================\n * 2026.02.09 : 박은정 : 학습 우측 패널 (LearningPanel) 스타일\n * Reference : mockup/learning.html (RIGHT PANEL), mockup/asset/css/layout.css\n * =========================================================================================== */\n\n/* 패널 컨테이너 — 우측에서 슬라이드 인 */\n.learning-panel {\n  position: fixed;\n  top: 48px; /* 헤더 아래 */\n  right: 0;\n  bottom: 0;\n  width: 420px;\n  max-width: 100vw;\n  z-index: 600;\n  background: #ffffff;\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  transform: translateX(100%);\n  opacity: 0;\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1),\n              opacity 0.35s ease;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.learning-panel--visible {\n  transform: translateX(0);\n  opacity: 1;\n}\n\n/* 패널 헤더 (닫기 버튼) */\n.learning-panel__header {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 12px 16px 4px;\n  flex-shrink: 0;\n}\n\n.learning-panel__back {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  border: none;\n  background: rgba(0, 0, 0, 0.04);\n  color: #9CA3AF;\n  cursor: pointer;\n  transition: all 150ms ease;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.learning-panel__back:hover {\n  background: rgba(0, 0, 0, 0.08);\n  color: #1F2937;\n}\n\n/* 장비 개요 영역 */\n.learning-panel__overview {\n  padding: 4px 24px 20px;\n  border-bottom: 1px solid #F3F4F6;\n  flex-shrink: 0;\n}\n\n.learning-panel__eq-name {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1F2937;\n  margin: 0 0 2px 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.learning-panel__eq-sub {\n  font-size: 12px;\n  color: #9CA3AF;\n  margin: 0 0 12px 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.learning-panel__eq-desc {\n  font-size: 13px;\n  color: #6B7280;\n  line-height: 1.6;\n  margin: 0 0 16px 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.learning-panel__specs {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  background: #F9FAFB;\n  border-radius: 12px;\n  padding: 10px 14px;\n}\n\n.learning-panel__spec {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 12px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.learning-panel__spec-label {\n  color: #9CA3AF;\n}\n\n.learning-panel__spec-value {\n  color: #1F2937;\n  font-weight: 500;\n}\n\n/* 학습 과정 목록 헤더 */\n.learning-panel__cards {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.learning-panel__cards-header {\n  padding: 16px 24px 8px;\n  flex-shrink: 0;\n}\n\n.learning-panel__cards-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1F2937;\n  margin: 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.learning-panel__cards-list {\n  padding: 0 16px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* ============================================\n * 아코디언 카드 (.lp-card)\n * ============================================ */\n.lp-card {\n  border-radius: 14px;\n  overflow: hidden;\n  border: 1px solid #F3F4F6;\n  transition: box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.lp-card:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n/* 카드 헤더 */\n.lp-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  cursor: pointer;\n  background: #ffffff;\n  transition: background 0.15s ease;\n  user-select: none;\n}\n\n.lp-card__header:hover {\n  background: #FAFBFC;\n}\n\n.lp-card__left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.lp-card__number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  flex-shrink: 0;\n  background: #F3F4F6;\n  color: #6B7280;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-card--completed .lp-card__number {\n  background: rgba(16, 185, 129, 0.1);\n  color: #10B981;\n}\n\n.lp-card--in-progress .lp-card__number {\n  background: rgba(59, 130, 246, 0.1);\n  color: #3B82F6;\n}\n\n.lp-card--active .lp-card__number {\n  background: #3B82F6;\n  color: #ffffff;\n}\n\n.lp-card__title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #1F2937;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-card__right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.lp-card__status {\n  font-size: 11px;\n  font-weight: 500;\n  color: #9CA3AF;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-card__status--completed {\n  color: #10B981;\n}\n\n.lp-card__status--in-progress {\n  color: #3B82F6;\n}\n\n.lp-card__chevron {\n  color: #9CA3AF;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.lp-card--active .lp-card__chevron {\n  transform: rotate(180deg);\n}\n\n/* 아코디언 본문 (펼침/접힘) */\n.lp-card__content {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.lp-card--active .lp-card__content {\n  max-height: 5000px; /* 충분히 큰 값 — monitoring 카드 제어/계측 데이터 포함 */\n}\n\n.lp-card__body {\n  padding: 0 16px 16px;\n}\n\n/* 활성 카드 강조 */\n.lp-card--active {\n  border-color: #3B82F6;\n  box-shadow: 0 2px 12px rgba(59, 130, 246, 0.08);\n}\n\n/* ============================================\n * 섹션 콘텐츠 (.lp-section)\n * ============================================ */\n.lp-section {\n  margin-bottom: 16px;\n}\n\n.lp-section:last-child {\n  margin-bottom: 0;\n}\n\n.lp-section__title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  margin: 0 0 8px 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-section__body {\n  font-size: 13px;\n  color: #6B7280;\n  line-height: 1.6;\n  margin: 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* 리스트 */\n.lp-section__list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.lp-section__list-item {\n  font-size: 13px;\n  color: #4B5563;\n  line-height: 1.5;\n  padding-left: 4px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* 태그 */\n.lp-section__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.lp-section__tag {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 8px;\n  font-size: 12px;\n  background: rgba(59, 130, 246, 0.06);\n  color: #3B82F6;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* 용어 정의 */\n.lp-section__terms {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.lp-term {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 12px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-term__name {\n  color: #1F2937;\n  white-space: nowrap;\n  flex-shrink: 0;\n  min-width: 70px;\n}\n\n.lp-term__def {\n  color: #6B7280;\n  line-height: 1.4;\n}\n\n/* 부품 목록 */\n.lp-section__parts {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n/* 2026.02.20 : 박은정 : 구성요소 부품 기본 스타일 */\n.lp-part {\n  background: #F9FAFB;\n  border-radius: 10px;\n  padding: 10px 12px;\n  transition: all 0.2s ease;\n  border: 1.5px solid transparent;\n}\n\n/* 2026.02.20 : 박은정 : 핫스팟 태그 연동 가능한 부품 — 클릭 가능 표시 */\n.lp-part--clickable {\n  cursor: pointer;\n}\n\n.lp-part--clickable:hover {\n  background: #EFF6FF;\n  border-color: #93C5FD;\n}\n\n/* 2026.02.20 : 박은정 : 핫스팟 태그가 표시 중인 활성 부품 */\n.lp-part--active {\n  background: #DBEAFE;\n  border-color: #3B82F6;\n}\n\n.lp-part--active .lp-part__name {\n  color: #1D4ED8;\n}\n\n/* 2026.05.14 : 박은정 : 클릭된 부품 바로 아래 인라인 모니터링 데이터 */\n.lp-part-inline-monitoring {\n  background: #F8FAFC;\n  border: 1px solid #DBEAFE;\n  border-top: none;\n  border-radius: 0 0 10px 10px;\n  padding: 8px 12px;\n  margin-top: -6px;\n  margin-bottom: 8px;\n}\n.lp-part-inline-monitoring .lp-data-row {\n  padding: 4px 0;\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n}\n.lp-part-inline-monitoring .lp-data-row__label {\n  color: #475569;\n}\n.lp-part-inline-monitoring .lp-data-row__value strong {\n  color: #0f172a;\n}\n\n/* 2026.02.20 : 박은정 : 핫스팟 태그 표시중 뱃지 */\n.lp-part__hotspot-badge {\n  display: inline-block;\n  font-size: 10px;\n  color: #2563EB;\n  margin-top: 4px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-part__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 2px;\n}\n\n.lp-part__name {\n  font-size: 12px;\n  color: #1F2937;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-part__role {\n  font-size: 11px;\n  color: #6B7280;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-part__detail {\n  font-size: 11px;\n  color: #9CA3AF;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* 데이터 모니터링 행 */\n.lp-section__data {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.lp-data-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  background: #F9FAFB;\n  border-radius: 8px;\n  font-size: 12px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-data-row__left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n.lp-data-row__label {\n  color: #374151;\n}\n\n.lp-data-row__desc {\n  font-size: 11px;\n  color: #6B7280;\n  font-weight: 400;\n}\n\n.lp-data-row__right {\n  display: flex;\n  align-items: center;\n}\n\n.lp-data-row__value {\n  color: #6B7280;\n}\n\n.lp-data-row__value strong {\n  color: #1F2937;\n  font-weight: 400;\n}\n\n/* 2026.02.12 : 박은정 : 우측 패널 모니터링 데이터 섹션 (제어 장비 + 계측 장비) */\n.lp-monitoring-data {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 12px;\n}\n\n/* 제어 장비 디바이스 카드 (우측 패널 monitoring 카드용) */\n.lp-data-device {\n  background: #F9FAFB;\n  border-radius: 10px;\n  padding: 10px 12px;\n  border: 1px solid #F3F4F6;\n  margin-bottom: 6px;\n}\n\n.lp-data-device:last-child {\n  margin-bottom: 0;\n}\n\n.lp-data-device__header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n  padding-bottom: 6px;\n  border-bottom: 1px solid #F3F4F6;\n}\n\n.lp-data-device__id {\n  font-size: 12px;\n  color: #374151;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-data-device__name {\n  font-size: 12px;\n  color: #6B7280;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  flex: 1;\n}\n\n.lp-data-device__status {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-data-device__status--running {\n  background: rgba(16, 185, 129, 0.08);\n  color: #059669;\n}\n\n.lp-data-device__status--stopped {\n  background: rgba(107, 114, 128, 0.08);\n  color: #6B7280;\n}\n\n/* 계측 장비 센서 그룹 (우측 패널 monitoring 카드용) */\n.lp-monitoring-group {\n  margin-bottom: 8px;\n}\n\n.lp-monitoring-group:last-child {\n  margin-bottom: 0;\n}\n\n.lp-monitoring-group__heading {\n  font-size: 12px;\n  color: #374151;\n  margin: 0 0 6px 0;\n  padding: 4px 8px;\n  background: rgba(59, 130, 246, 0.04);\n  border-radius: 6px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* 시나리오 목록 */\n.lp-section__scenarios {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.lp-scenario {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  background: #F9FAFB;\n  border-radius: 10px;\n  font-size: 13px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* 2026.02.11 : 박은정 : 클릭 가능한 시나리오 스타일 */\n.lp-scenario--clickable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.lp-scenario--clickable:hover {\n  background: #EFF6FF;\n  border: 1px solid #3B82F6;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);\n}\n\n.lp-scenario__num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 7px;\n  font-size: 11px;\n  background: rgba(59, 130, 246, 0.08);\n  color: #3B82F6;\n  flex-shrink: 0;\n}\n\n.lp-scenario__name {\n  flex: 1;\n  color: #1F2937;\n}\n\n.lp-scenario__duration {\n  font-size: 11px;\n  color: #9CA3AF;\n  font-weight: 500;\n}\n\n/* 학습 완료 버튼 */\n.lp-card__action {\n  margin-top: 16px;\n  padding-top: 12px;\n  border-top: 1px solid #F3F4F6;\n}\n\n.lp-card__complete-btn {\n  display: block;\n  width: 100%;\n  padding: 10px;\n  background: #3B82F6;\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 150ms ease;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.lp-card__complete-btn:hover {\n  background: #2563EB;\n}\n\n/* ===========================================================================================\n * 2026.02.12 : 박은정 : 평가 퀴즈 (LearningPanel evaluation 카드) 스타일\n * Reference : doc/equipment-description/*_test.md (객관식 평가 문항)\n * =========================================================================================== */\n\n/* 퀴즈 컨테이너 */\n.lp-quiz {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n/* 진행 상황 바 */\n.lp-quiz__progress {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.lp-quiz__progress-info {\n  display: flex;\n  align-items: baseline;\n  gap: 2px;\n  flex-shrink: 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-quiz__progress-current {\n  font-size: 16px;\n  font-weight: 700;\n  color: #3B82F6;\n}\n\n.lp-quiz__progress-sep {\n  font-size: 13px;\n  color: #9CA3AF;\n}\n\n.lp-quiz__progress-total {\n  font-size: 13px;\n  color: #6B7280;\n  font-weight: 500;\n}\n\n.lp-quiz__progress-bar {\n  flex: 1;\n  height: 6px;\n  background: #F3F4F6;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.lp-quiz__progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #3B82F6, #60A5FA);\n  border-radius: 3px;\n  transition: width 0.4s ease;\n}\n\n/* 결과 문항 요약 그리드 */\n.lp-quiz__summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.lp-quiz__summary-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 44px;\n  border-radius: 8px;\n  border: 1px solid #E5E7EB;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-quiz__summary-item--correct {\n  background: rgba(16, 185, 129, 0.06);\n  border-color: rgba(16, 185, 129, 0.3);\n}\n\n.lp-quiz__summary-item--wrong {\n  background: rgba(239, 68, 68, 0.06);\n  border-color: rgba(239, 68, 68, 0.3);\n}\n\n.lp-quiz__summary-num {\n  font-size: 11px;\n  font-weight: 600;\n  color: #6B7280;\n}\n\n.lp-quiz__summary-mark {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.lp-quiz__summary-item--correct .lp-quiz__summary-mark {\n  color: #059669;\n}\n\n.lp-quiz__summary-item--wrong .lp-quiz__summary-mark {\n  color: #DC2626;\n}\n\n/* 결과 박스 */\n.lp-quiz__result {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.lp-quiz__result--pass {\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.08), rgba(16, 185, 129, 0.15));\n  border: 1px solid rgba(16, 185, 129, 0.3);\n}\n\n.lp-quiz__result--fail {\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.08), rgba(239, 68, 68, 0.15));\n  border: 1px solid rgba(239, 68, 68, 0.3);\n}\n\n.lp-quiz__result-score {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n}\n\n.lp-quiz__result-label {\n  font-size: 11px;\n  color: #6B7280;\n  font-weight: 500;\n}\n\n.lp-quiz__result-value {\n  font-size: 22px;\n  font-weight: 700;\n  color: #1F2937;\n}\n\n.lp-quiz__result--pass .lp-quiz__result-value {\n  color: #059669;\n}\n\n.lp-quiz__result--fail .lp-quiz__result-value {\n  color: #DC2626;\n}\n\n.lp-quiz__result-detail {\n  font-size: 13px;\n  color: #4B5563;\n  flex: 1;\n}\n\n.lp-quiz__result-badge {\n  padding: 4px 12px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.lp-quiz__result-badge--pass {\n  background: rgba(16, 185, 129, 0.15);\n  color: #059669;\n}\n\n.lp-quiz__result-badge--fail {\n  background: rgba(239, 68, 68, 0.15);\n  color: #DC2626;\n}\n\n/* 문항 카드 */\n.lp-quiz__question {\n  background: #F9FAFB;\n  border-radius: 12px;\n  padding: 14px 16px;\n  border: 1px solid #F3F4F6;\n  transition: border-color 0.2s ease;\n}\n\n.lp-quiz__question--correct {\n  border-color: rgba(16, 185, 129, 0.4);\n  background: rgba(16, 185, 129, 0.03);\n}\n\n.lp-quiz__question--wrong {\n  border-color: rgba(239, 68, 68, 0.4);\n  background: rgba(239, 68, 68, 0.03);\n}\n\n.lp-quiz__q-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.lp-quiz__q-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  background: rgba(59, 130, 246, 0.08);\n  color: #3B82F6;\n  flex-shrink: 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-quiz__q-cat {\n  font-size: 11px;\n  color: #9CA3AF;\n  font-weight: 500;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-quiz__q-mark {\n  margin-left: auto;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.lp-quiz__q-mark--correct {\n  color: #059669;\n}\n\n.lp-quiz__q-mark--wrong {\n  color: #DC2626;\n}\n\n.lp-quiz__q-text {\n  font-size: 13px;\n  font-weight: 500;\n  color: #1F2937;\n  line-height: 1.5;\n  margin: 0 0 10px 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* 선택지 */\n.lp-quiz__choices {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.lp-quiz__choice {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: #ffffff;\n  border: 1.5px solid #E5E7EB;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-quiz__choice:hover {\n  border-color: #D1D5DB;\n  background: #FAFBFC;\n}\n\n.lp-quiz__choice--selected {\n  border-color: #3B82F6;\n  background: rgba(59, 130, 246, 0.04);\n}\n\n.lp-quiz__choice--selected:hover {\n  border-color: #3B82F6;\n  background: rgba(59, 130, 246, 0.06);\n}\n\n.lp-quiz__choice--correct {\n  border-color: #10B981 !important;\n  background: rgba(16, 185, 129, 0.06) !important;\n}\n\n.lp-quiz__choice--wrong {\n  border-color: #EF4444 !important;\n  background: rgba(239, 68, 68, 0.06) !important;\n}\n\n.lp-quiz__choice--disabled {\n  cursor: default;\n  pointer-events: none;\n}\n\n.lp-quiz__choice-num {\n  font-size: 13px;\n  color: #6B7280;\n  flex-shrink: 0;\n  line-height: 1.5;\n}\n\n.lp-quiz__choice--selected .lp-quiz__choice-num {\n  color: #3B82F6;\n}\n\n.lp-quiz__choice--correct .lp-quiz__choice-num {\n  color: #059669;\n  font-weight: 600;\n}\n\n.lp-quiz__choice--wrong .lp-quiz__choice-num {\n  color: #DC2626;\n}\n\n.lp-quiz__choice-text {\n  font-size: 13px;\n  color: #374151;\n  line-height: 1.5;\n}\n\n.lp-quiz__choice--correct .lp-quiz__choice-text {\n  color: #059669;\n  font-weight: 600;\n}\n\n.lp-quiz__choice--wrong .lp-quiz__choice-text {\n  color: #DC2626;\n}\n\n/* 해설 */\n.lp-quiz__explanation {\n  margin-top: 10px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  font-size: 12px;\n  line-height: 1.6;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.lp-quiz__explanation--correct {\n  background: rgba(16, 185, 129, 0.06);\n  border-left: 3px solid #10B981;\n}\n\n.lp-quiz__explanation--wrong {\n  background: rgba(239, 68, 68, 0.06);\n  border-left: 3px solid #EF4444;\n}\n\n.lp-quiz__explanation-label {\n  display: inline-block;\n  font-weight: 700;\n  color: #4B5563;\n  margin-right: 6px;\n}\n\n.lp-quiz__explanation-text {\n  color: #4B5563;\n}\n\n/* 액션 버튼 */\n.lp-quiz__actions {\n  margin-top: 8px;\n  padding-top: 12px;\n  border-top: 1px solid #F3F4F6;\n}\n\n.lp-quiz__submit-btn {\n  display: block;\n  width: 100%;\n  padding: 12px;\n  background: #3B82F6;\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 150ms ease, opacity 150ms ease;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.lp-quiz__submit-btn:hover:not(:disabled) {\n  background: #2563EB;\n}\n\n.lp-quiz__submit-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.lp-quiz__retry-btn {\n  display: block;\n  width: 100%;\n  padding: 12px;\n  background: #ffffff;\n  color: #3B82F6;\n  border: 1.5px solid #3B82F6;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 150ms ease;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.lp-quiz__retry-btn:hover {\n  background: rgba(59, 130, 246, 0.04);\n}\n\n/* ===========================================================================================\n * 2026.02.11 : 박은정 : 모니터링 좌측 패널 (MonitoringPanel) 스타일\n * Reference : mockup/learning.html (LEFT PANEL), 우측 패널(.learning-panel) 동일 스타일 기반\n * =========================================================================================== */\n\n/* 패널 컨테이너 — 좌측에서 슬라이드 인 (우측 패널과 대칭) */\n.monitoring-panel {\n  position: fixed;\n  top: 48px; /* 헤더 아래 */\n  left: 0;\n  bottom: 0;\n  width: 380px;\n  max-width: 100vw;\n  z-index: 600;\n  background: #ffffff;\n  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  transform: translateX(-100%);\n  opacity: 0;\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1),\n              opacity 0.35s ease;\n  overflow: hidden;\n}\n\n.monitoring-panel--visible {\n  transform: translateX(0);\n  opacity: 1;\n}\n\n/* 2026.02.12 : 박은정 : 패널 헤더 → \"모니터링\" 타이틀 + 운전 상태 뱃지 (장비명 3중 중복 해소) */\n.monitoring-panel__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px 12px;\n  border-bottom: 1px solid #F3F4F6;\n  flex-shrink: 0;\n}\n\n.monitoring-panel__title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1F2937;\n  margin: 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* 장비 상태 뱃지 */\n.monitoring-panel__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.monitoring-panel__status-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.monitoring-panel__status--running {\n  background: rgba(16, 185, 129, 0.08);\n  color: #059669;\n}\n\n.monitoring-panel__status--running .monitoring-panel__status-dot {\n  background: #10B981;\n  box-shadow: 0 0 6px rgba(16, 185, 129, 0.4);\n  animation: mp-dot-pulse 2s infinite;\n}\n\n@keyframes mp-dot-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n.monitoring-panel__status--stopped {\n  background: rgba(107, 114, 128, 0.08);\n  color: #6B7280;\n}\n\n.monitoring-panel__status--stopped .monitoring-panel__status-dot {\n  background: #9CA3AF;\n}\n\n.monitoring-panel__status--warning {\n  background: rgba(245, 158, 11, 0.08);\n  color: #D97706;\n}\n\n.monitoring-panel__status--warning .monitoring-panel__status-dot {\n  background: #F59E0B;\n  animation: mp-dot-pulse 1.5s infinite;\n}\n\n.monitoring-panel__status--alarm {\n  background: rgba(239, 68, 68, 0.08);\n  color: #DC2626;\n}\n\n.monitoring-panel__status--alarm .monitoring-panel__status-dot {\n  background: #EF4444;\n  animation: mp-dot-pulse 1s infinite;\n}\n\n/* 2026.02.12 : 박은정 : 장비 설명 영역 제거 (우측 학습 패널에서 제공하므로 중복 해소) */\n\n/* 스크롤 가능한 본문 */\n.monitoring-panel__body {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  /* 2026.02.12 : 박은정 : 상단 padding 추가 */\n  padding: 16px 16px 24px;\n}\n\n/* 2025.02.11 : 박은정 : 아코디언 카드 리스트 (학습 시나리오와 동일한 스타일) */\n.monitoring-panel__cards-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* 2026.02.11 : 박은정 : 플레이백 패널 컨테이너 (푸터 위쪽에 고정) */\n.playback-panel-container {\n  position: fixed;\n  bottom: 80px; /* 푸터 높이만큼 위로 */\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 99; /* 푸터(z-index: 100)보다 낮게 */\n  width: 90%;\n  max-width: 800px;\n  padding: 0 20px;\n}\n\n/* 2026.02.11 : 박은정 : 플레이백 패널 스타일 */\n.playback-panel {\n  background: #ffffff;\n  border-radius: 14px;\n  border: 1px solid #F3F4F6;\n  box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n}\n\n/* 2026.02.12 : 박은정 : 헤더 (시나리오명 + 현재 단계 뱃지 + 자세히 보기 토글) */\n.playback-panel__header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-bottom: 1px solid #F3F4F6;\n  background: #FAFBFC;\n}\n\n.playback-panel__title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1F2937;\n  margin: 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  white-space: nowrap;\n}\n\n/* 2026.02.12 : 박은정 : 현재 활성 단계 뱃지 */\n.playback-panel__phase-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 400;\n  color: #ffffff;\n  white-space: nowrap;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  line-height: 1.4;\n  transition: background-color 0.3s ease;\n}\n\n/* 2026.02.12 : 박은정 : 트랙 자세히 보기 / 접기 토글 버튼 */\n.playback-panel__toggle-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  margin-left: auto;\n  padding: 3px 10px;\n  border: 1px solid #E5E7EB;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #6B7280;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  flex-shrink: 0;\n}\n\n.playback-panel__toggle-btn:hover {\n  background: #F9FAFB;\n  border-color: #D1D5DB;\n  color: #374151;\n}\n\n.playback-panel__toggle-text {\n  line-height: 1;\n}\n\n.playback-panel__toggle-icon {\n  transition: transform 0.2s ease;\n}\n\n.playback-panel__toggle-icon--expanded {\n  transform: rotate(180deg);\n}\n\n.playback-panel__content {\n  padding: 12px 16px;\n}\n\n/* 2026.02.12 : 박은정 : 플레이백 컨트롤 스타일 — 고정 레이아웃 (flex-wrap 제거), 일관된 크기 */\n.playback-controls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n/* 2026.02.12 : 박은정 : 재생/일시정지/정지 버튼 3개 분리 */\n.playback-controls__buttons {\n  display: flex;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.playback-controls__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: 1px solid #E5E7EB;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #6B7280;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  padding: 0;\n}\n\n.playback-controls__btn:hover:not(:disabled) {\n  background: #F9FAFB;\n  border-color: #D1D5DB;\n  color: #1F2937;\n}\n\n.playback-controls__btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.playback-controls__btn--play {\n  color: #3B82F6;\n}\n\n.playback-controls__btn--play:hover:not(:disabled) {\n  background: #EFF6FF;\n  border-color: #93C5FD;\n}\n\n.playback-controls__btn--pause {\n  color: #F59E0B;\n}\n\n.playback-controls__btn--pause:hover:not(:disabled) {\n  background: #FFFBEB;\n  border-color: #FCD34D;\n}\n\n.playback-controls__btn--stop {\n  color: #EF4444;\n}\n\n.playback-controls__btn--stop:hover:not(:disabled) {\n  background: #FEF2F2;\n  border-color: #FCA5A5;\n}\n\n/* 2026.02.12 : 박은정 : 시간 표시 — 고정 폭 */\n.playback-controls__time {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #1F2937;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  min-width: 88px;\n  flex-shrink: 0;\n}\n\n.playback-controls__time-current {\n  color: #3B82F6;\n  font-variant-numeric: tabular-nums;\n}\n\n.playback-controls__time-separator {\n  color: #9CA3AF;\n}\n\n.playback-controls__time-total {\n  color: #6B7280;\n  font-variant-numeric: tabular-nums;\n}\n\n/* 2026.02.12 : 박은정 : 시크바 영역 (단계 스트립 + 시크바를 감싸는 래퍼) */\n.playback-controls__seek-area {\n  flex: 1;\n  min-width: 120px;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n/* 2026.02.12 : 박은정 : 재생바 상단 단계 표시 스트립 */\n/* 2026.02.13 : 박은정 : 높이 16px → 22px로 확대하여 단계 텍스트 가독성 향상 */\n.playback-controls__phase-strip {\n  position: relative;\n  height: 22px;\n  border-radius: 3px;\n  overflow: hidden;\n  background: #F3F4F6;\n}\n\n.playback-controls__phase-segment {\n  position: absolute;\n  top: 0;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  opacity: 0.65;\n  transition: opacity 0.15s ease;\n}\n\n.playback-controls__phase-segment:hover {\n  opacity: 0.9;\n}\n\n/* 2026.02.13 : 박은정 : 현재 활성 단계 하이라이트 (불투명도 + 테두리 + 그림자) */\n.playback-controls__phase-segment--active {\n  opacity: 1;\n  box-shadow: 0 0 0 1.5px #ffffff, 0 0 6px rgba(0, 0, 0, 0.25);\n  z-index: 1;\n}\n\n.playback-controls__phase-segment--active .playback-controls__phase-segment-text {\n  font-weight: 400;\n}\n\n/* 2026.02.13 : 박은정 : 텍스트 크기 9px → 11px, text-shadow 강화하여 가독성 향상 */\n.playback-controls__phase-segment-text {\n  font-size: 11px;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0 4px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  line-height: 1;\n}\n\n/* 2026.02.12 : 박은정 : 시크바 — seek-area 내부 (색상을 현재 단계에 맞게 변경) */\n.playback-controls__seek {\n  position: relative;\n  height: 6px;\n  background: #F3F4F6;\n  border-radius: 3px;\n  cursor: pointer;\n}\n\n.playback-controls__seek-slider {\n  position: absolute;\n  top: -4px;\n  left: 0;\n  width: 100%;\n  height: 14px;\n  opacity: 0;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.playback-controls__seek-progress {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  border-radius: 3px;\n  pointer-events: none;\n  z-index: 1;\n  transition: width 0.1s linear, background-color 0.3s ease;\n}\n\n/* 2026.02.12 : 박은정 : 재생 속도 — 라벨 제거, 콤팩트 */\n.playback-controls__speed {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.playback-controls__speed-select {\n  padding: 3px 6px;\n  border: 1px solid #E5E7EB;\n  border-radius: 5px;\n  font-size: 11px;\n  color: #1F2937;\n  background: #ffffff;\n  cursor: pointer;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.playback-controls__speed-select:hover {\n  border-color: #D1D5DB;\n}\n\n/* 2026.02.12 : 박은정 : 플레이백 트랙 — 레이블 + 타임라인 2열 레이아웃, 고정 크기 */\n.playback-track {\n  display: flex;\n  background: #FAFBFC;\n  border-radius: 8px;\n  border: 1px solid #E5E7EB;\n  overflow: hidden;\n}\n\n/* 2026.02.12 : 박은정 : 레이블 열 (좌측 고정 64px) */\n.playback-track__labels {\n  display: flex;\n  flex-direction: column;\n  width: 64px;\n  flex-shrink: 0;\n  border-right: 1px solid #E5E7EB;\n  background: #F9FAFB;\n}\n\n.playback-track__label {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding-right: 6px;\n  font-size: 9px;\n  font-weight: 600;\n  color: #6B7280;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.playback-track__label--phase {\n  height: 22px;\n  font-size: 9px;\n  font-weight: 500;\n  color: #9CA3AF;\n  border-bottom: 1px solid #E5E7EB;\n}\n\n.playback-track__label--state {\n  height: 16px;\n  border-bottom: 1px solid #F3F4F6;\n}\n\n.playback-track__label--state:last-child {\n  border-bottom: none;\n}\n\n/* 2026.02.12 : 박은정 : 센서 라벨 (제어 라벨과 동일 높이, 색상만 다름) */\n.playback-track__label--sensor {\n  height: 16px;\n  border-bottom: 1px solid #F3F4F6;\n  color: #9CA3AF;\n  font-size: 8px;\n}\n\n.playback-track__label--sensor:last-child {\n  border-bottom: none;\n}\n\n/* 2026.02.12 : 박은정 : 제어/센서 섹션 헤더 (레이블 열 내) */\n.playback-track__section-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 14px;\n  font-size: 8px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n  border-bottom: 1px solid #E5E7EB;\n  border-top: 1px solid #E5E7EB;\n}\n\n.playback-track__section-header--control {\n  color: #3B82F6;\n  background: #EFF6FF;\n}\n\n.playback-track__section-header--sensor {\n  color: #F59E0B;\n  background: #FFFBEB;\n}\n\n/* 2026.02.12 : 박은정 : 타임라인 열 (우측, 나머지 영역) */\n.playback-track__timeline {\n  position: relative;\n  flex: 1;\n  cursor: pointer;\n}\n\n/* 2026.02.12 : 박은정 : Phase 구간 행 — 컴팩트 (22px) + 텍스트 라벨 */\n.playback-track__phases-row {\n  position: relative;\n  height: 22px;\n  border-bottom: 1px solid #E5E7EB;\n}\n\n.playback-track__phase {\n  position: absolute;\n  top: 0;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  opacity: 0.85;\n}\n\n.playback-track__phase-text {\n  font-size: 10px;\n  font-weight: 500;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0 4px;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* 2026.02.12 : 박은정 : 제어/센서 섹션 구분선 (타임라인 측, 레이블 섹션 헤더와 높이 일치) */\n.playback-track__section-divider {\n  height: 14px;\n  border-bottom: 1px solid #E5E7EB;\n  border-top: 1px solid #E5E7EB;\n  background: #F9FAFB;\n}\n\n/* 2026.02.12 : 박은정 : 제어 상태 변화 행 (ON/OFF 사각형) */\n.playback-track__state-row {\n  position: relative;\n  height: 16px;\n  border-bottom: 1px solid #F3F4F6;\n  background: #FDFDFE;\n}\n\n.playback-track__state-row:last-child {\n  border-bottom: none;\n}\n\n/* 2026.02.12 : 박은정 : 센서 행 (제어 행보다 약간 밝은 배경) */\n.playback-track__sensor-row {\n  background: #FEFEFE;\n}\n\n.playback-track__state-range {\n  position: absolute;\n  top: 2px;\n  bottom: 2px;\n  border-radius: 2px;\n  opacity: 0.55;\n  transition: opacity 0.15s ease;\n  overflow: hidden;\n}\n\n.playback-track__state-range:hover {\n  opacity: 0.85;\n}\n\n/* 2026.02.12 : 박은정 : 센서 구간 사각형 (패턴으로 제어와 시각적 구분) */\n.playback-track__sensor-range {\n  opacity: 0.45;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.playback-track__sensor-range:hover {\n  opacity: 0.75;\n}\n\n/* 2026.02.12 : 박은정 : 제어 변경점 마커 (ON 구간 내 수치 값 변경 위치를 흰색 세로선으로 표시) */\n.playback-track__change-marker {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  background: rgba(255, 255, 255, 0.85);\n  z-index: 2;\n  pointer-events: auto;\n  cursor: help;\n  box-shadow: 0 0 3px rgba(0, 0, 0, 0.25);\n}\n\n.playback-track__change-marker::before {\n  content: '';\n  position: absolute;\n  top: -2px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 3px solid transparent;\n  border-right: 3px solid transparent;\n  border-top: 3px solid rgba(255, 255, 255, 0.95);\n}\n\n/* 2026.02.12 : 박은정 : 재생 인디케이터 — 타임라인 전체 높이 관통 */\n.playback-track__indicator {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  background: #EF4444;\n  z-index: 6;\n  pointer-events: none;\n  box-shadow: 0 0 4px rgba(239, 68, 68, 0.4);\n}\n\n.playback-track__indicator::before {\n  content: '';\n  position: absolute;\n  top: -3px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid #EF4444;\n}\n\n.monitoring-panel__body::-webkit-scrollbar {\n  width: 4px;\n}\n\n.monitoring-panel__body::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.monitoring-panel__body::-webkit-scrollbar-thumb {\n  background: #D1D5DB;\n  border-radius: 2px;\n}\n\n/* 2025.02.11 : 박은정 : 아코디언 카드 (학습 시나리오와 동일한 스타일) */\n.monitoring-panel__card {\n  border-radius: 14px;\n  overflow: hidden;\n  border: 1px solid #F3F4F6;\n  transition: box-shadow 0.2s ease, border-color 0.2s ease;\n  margin-bottom: 8px;\n}\n\n.monitoring-panel__card:last-child {\n  margin-bottom: 0;\n}\n\n.monitoring-panel__card:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n/* 활성 카드 강조 */\n.monitoring-panel__card--active {\n  border-color: #3B82F6;\n  box-shadow: 0 2px 12px rgba(59, 130, 246, 0.08);\n}\n\n/* 카드 헤더 */\n.monitoring-panel__card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  cursor: pointer;\n  background: #ffffff;\n  transition: background 0.15s ease;\n  user-select: none;\n}\n\n.monitoring-panel__card-header:hover {\n  background: #FAFBFC;\n}\n\n.monitoring-panel__card-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.monitoring-panel__card-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  flex-shrink: 0;\n  background: #F3F4F6;\n  color: #6B7280;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.monitoring-panel__card-number--active {\n  background: #3B82F6;\n  color: #ffffff;\n}\n\n.monitoring-panel__card-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #1F2937;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.monitoring-panel__card-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.monitoring-panel__card-status {\n  font-size: 11px;\n  font-weight: 500;\n  color: #9CA3AF;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.monitoring-panel__card-chevron {\n  color: #9CA3AF;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.monitoring-panel__card-chevron--open {\n  transform: rotate(180deg);\n}\n\n/* 아코디언 본문 (펼침/접힘) */\n.monitoring-panel__card-content {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.monitoring-panel__card-content--open {\n  max-height: 2000px; /* 충분히 큰 값 */\n}\n\n.monitoring-panel__card-body {\n  padding: 0 16px 16px;\n}\n\n/* 제어 장비 목록 */\n.monitoring-panel__devices {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* 제어 장비 카드 */\n.mp-device {\n  background: #F9FAFB;\n  border-radius: 12px;\n  padding: 12px 14px;\n  border: 1px solid #F3F4F6;\n  transition: border-color 0.2s ease;\n}\n\n.mp-device:hover {\n  border-color: #E5E7EB;\n}\n\n.mp-device__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n\n.mp-device__info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mp-device__id {\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.mp-device__name {\n  font-size: 12px;\n  color: #6B7280;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* 장비 상태 뱃지 (개별 장비) */\n.mp-device__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 500;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.mp-device__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.mp-device__status--running {\n  background: rgba(16, 185, 129, 0.08);\n  color: #059669;\n}\n\n.mp-device__status--running .mp-device__status-dot {\n  background: #10B981;\n}\n\n.mp-device__status--stopped {\n  background: rgba(107, 114, 128, 0.08);\n  color: #6B7280;\n}\n\n.mp-device__status--stopped .mp-device__status-dot {\n  background: #9CA3AF;\n}\n\n.mp-device__status--warning {\n  background: rgba(245, 158, 11, 0.08);\n  color: #D97706;\n}\n\n.mp-device__status--warning .mp-device__status-dot {\n  background: #F59E0B;\n}\n\n.mp-device__role {\n  font-size: 11px;\n  color: #9CA3AF;\n  margin-bottom: 6px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* 제어 포인트 목록 */\n.mp-device__controls {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px solid #F3F4F6;\n}\n\n.mp-ctrl {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 0;\n}\n\n.mp-ctrl__left {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.mp-ctrl__type {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 28px;\n  padding: 1px 4px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  background: rgba(99, 102, 241, 0.08);\n  color: #6366F1;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.mp-ctrl__name {\n  font-size: 12px;\n  color: #4B5563;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.mp-ctrl__right {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.mp-ctrl__value {\n  font-size: 12px;\n  font-weight: 600;\n  color: #1F2937;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.mp-ctrl__unit {\n  font-size: 11px;\n  color: #9CA3AF;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* 모니터링 센서 섹션 */\n.monitoring-panel__sections {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.mp-section {\n  background: #F9FAFB;\n  border-radius: 12px;\n  padding: 12px 14px;\n  border: 1px solid #F3F4F6;\n}\n\n.mp-section__title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  margin: 0 0 8px 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.mp-section__rows {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n/* 모니터링 데이터 행 */\n.mp-data-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 10px;\n  background: #ffffff;\n  border-radius: 8px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.mp-data-row__left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mp-data-row__indicator {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.mp-data-row__indicator--normal {\n  background: #10B981;\n}\n\n.mp-data-row__indicator--warning {\n  background: #F59E0B;\n}\n\n.mp-data-row__indicator--alarm {\n  background: #EF4444;\n}\n\n.mp-data-row__labels {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.mp-data-row__id {\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.mp-data-row__desc {\n  font-size: 11px;\n  color: #9CA3AF;\n}\n\n.mp-data-row__right {\n  display: flex;\n  align-items: baseline;\n  gap: 3px;\n}\n\n.mp-data-row__value {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1F2937;\n}\n\n.mp-data-row__unit {\n  font-size: 11px;\n  color: #9CA3AF;\n  font-weight: 500;\n}\n\n/* ===========================================================================================\n * 2026.02.13 : 박은정 : P&ID 다이어그램 (PidDiagram) 스타일\n * Reference : packages/scjeil-smart_ict_lab-app/src/components/PidDiagram.tsx\n * =========================================================================================== */\n\n/* P&ID SVG 컨테이너 */\n.pid-diagram {\n  width: 100%;\n  height: auto;\n  display: block;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  background: #DFE3E8;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n}\n\n/* P&ID 섹션 래퍼 (모니터링 패널 내) */\n.monitoring-panel__pid {\n  padding: 0 0 12px 0;\n}\n\n.monitoring-panel__pid-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n  margin: 0 0 8px 0;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* 2026.05.13 : 박은정 : 시뮬레이션 값 변화 누적 그래프 (좌측 패널 컴팩트 버전) */\n.playback-chart {\n  padding: 8px;\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  font-family: 'Inter', 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.playback-chart__header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 4px;\n  gap: 6px;\n}\n\n.playback-chart__title {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.playback-chart__hint {\n  font-size: 9px;\n  color: #9ca3af;\n  white-space: nowrap;\n}\n\n/* 2026.05.13 : 박은정 : 범례 chip 버튼 (다중 토글, 좁은 패널에 wrap) */\n.playback-chart__legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n  margin-top: 6px;\n}\n\n.playback-chart__chip {\n  font-family: inherit;\n  font-size: 9px;\n  font-weight: 600;\n  padding: 2px 6px;\n  border: 1px solid;\n  border-radius: 999px;\n  cursor: pointer;\n  line-height: 1.2;\n  white-space: nowrap;\n  transition: opacity 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n}\n\n.playback-chart__chip:hover {\n  opacity: 0.85;\n}\n\n.playback-chart__chip--off {\n  opacity: 0.65;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
